// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T17:23:36.473Z
// Property: The Jax (ID: 6767906449167336)
// Collections: 30 amenities, 7 floorplans (live), 70 photos, 38 POIs, 6 reviews, 6 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167336",
  "property_external_id": "100160112",
  "property_zillow_url": "https://www.zillow.com/apartments/monroe-ga/the-jax/ChhTNR/",
  "property_apartments_url": "https://www.apartments.com/the-jax-monroe-ga/bsenzdb/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Jax/data=!4m2!3m1!1s0x0:0x82965ffc9d5ad7be?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "21798383754",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-jax",
  "property_name": "The Jax",
  "property_website_url": "https://www.liveatthejax.com/",
  "property_domain": "https://www.liveatthejax.com/",
  "property_address": "200 Aycock Ave",
  "property_full_address": "200 Aycock Ave, Monroe, GA 30655",
  "property_address_1": "200 Aycock Ave",
  "property_address_2": null,
  "property_address_city": "Monroe",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30655",
  "property_address_country": "US",
  "property_address_county": "Walton County",
  "property_neighborhood_address": "Walton County",
  "property_address_latitude": "33.8090848",
  "property_address_longitude": "-83.6839868",
  "property_email": null,
  "property_phone": "(470) 570-3082",
  "property_call_tracking_phone": "844-836-4040",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": "https://www.axiares.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "Welcome to The Jax in Monroe, GA, where modern living meets luxurious comfort. Choose from spacious one, two, or three-bedroom floor plans featuring granite countertops and hardwood floors. Unwind by the resort-style pool, work out in our 24-hour fitness center, or enjoy the dog park. Your ideal lifestyle awaits!",
  "property_long_description": "Welcome to The Jax, your ideal apartment community nestled in the heart of Monroe, GA. Offering an array of thoughtfully designed floor plans, including one, two, and three-bedroom options, The Jax caters to diverse lifestyles and needs. Each apartment showcases open concept living with large bedrooms, 9-ft high ceilings, and serene views that create a peaceful retreat. Enjoy modern comforts with granite countertops, stainless steel appliances, hardwood floors, and spacious walk-in closets, all designed to elevate your living experience.\n\nAt The Jax, our exceptional amenities are tailored to enhance your lifestyle. Dive into relaxation at our resort-style swimming pool or enjoy a fun-filled day with friends at our poolside grill and sand volleyball court. For those who work from home, our business center and 24-hour fitness center provide everything you need to stay productive and fit. Plus, with controlled access and valet trash service, you can rest easy knowing your comfort and convenience are our priorities.\n\nTake advantage of our Luxor One package lockers, EV charging stations, and community-wide WiFi to stay connected and on the go. Furry friends are welcome too—fringe benefits include a dog park complete with a pet wash station.\n\nExperience the perfect blend of luxury, community, and convenience at The Jax. Don’t wait any longer to find your new home! Browse our availability or schedule a tour today to discover everything we have to offer. Your dream apartment awaits in Monroe, GA!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-8e28-73bb-ae61-669ced540cf6.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a modern apartment complex featuring a large L-shaped swimming pool and lounge area.",
    "public_id": "019d7846-8e28-73bb-ae61-669ced540cf6",
    "storage_key": "property/6767906449167336/019d7846-8e28-73bb-ae61-669ced540cf6.webp",
    "width": 1280,
    "height": 719
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167336/019f94ba-c9ea-73ec-b9d6-d49e9266894c.mp4",
  "property_featured_video_media": {
    "public_id": "019f94ba-c9ea-73ec-b9d6-d49e9266894c",
    "storage_key": "property/6767906449167336/019f94ba-c9ea-73ec-b9d6-d49e9266894c.mp4",
    "thumbnail_key": "property/6767906449167336/019f94ba-c9ea-73ec-b9d6-d49e9266894c_thumb.webp",
    "size_bytes": 56044635,
    "classification": "Community",
    "title": "Explore the Amenities and Grounds of Our Apartment Community",
    "description": "Discover the resort-style amenities available to residents, including a state-of-the-art fitness center, social lounge, outdoor recreation areas, and more."
  },
  "property_total_units": "96",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.66666666666666",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Security Deposit (Refundable)\n$250.00",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "breed restrictions apply",
  "property_pet_policy_description": "We welcome cats and dogs (breed restrictions apply), up to two pets per home. One-time pet fee: $350. Monthly pet rent: $25.",
  "property_petpolicy_info": "Pet Policy\nPet Types: Cats & Dogs\n\nBreed Restrictions Apply\n\nPet Fees\nFee: $350.00\n\nRent: $25.00",
  "property_online_leasing_url": "https://thejaxaxia.prospectportal.com/Monroe/The Jax",
  "property_resident_portal_url": "https://thejaxaxia.residentportal.com/auth",
  "property_apply_now_url": "https://thejaxaxia.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/100160112/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-f0f3-7172-aa35-da5bdcefa599.webp",
  "property_primary_logo_media": {
    "alt_text": "The Jax logo",
    "public_id": "019d54f6-f0f3-7172-aa35-da5bdcefa599",
    "storage_key": "property/6767906449167336/019d54f6-f0f3-7172-aa35-da5bdcefa599.webp",
    "width": 277,
    "height": 235
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d745b-e79f-74f7-87ae-b8582479e4e2.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Jax logo with a dark blue circle and a stylized J.",
    "public_id": "019d745b-e79f-74f7-87ae-b8582479e4e2",
    "storage_key": "property/6767906449167336/019d745b-e79f-74f7-87ae-b8582479e4e2.webp",
    "width": 500,
    "height": 300
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019df439-e65b-7138-850b-1a84f10799ea.webp",
  "property_fav_icon_media": {
    "alt_text": "Generic blue circle icon",
    "public_id": "019df439-e65b-7138-850b-1a84f10799ea",
    "storage_key": "company/5767906449162258/019df439-e65b-7138-850b-1a84f10799ea.webp",
    "width": 48,
    "height": 48
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-3406-702c-ad33-5853f214ce05.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d54f7-3406-702c-ad33-5853f214ce05",
    "storage_key": "property/6767906449167336/019d54f7-3406-702c-ad33-5853f214ce05.webp",
    "width": 277,
    "height": 235
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-285b-7318-8cbf-ef1d684612e7.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d54f7-285b-7318-8cbf-ef1d684612e7",
    "storage_key": "property/6767906449167336/019d54f7-285b-7318-8cbf-ef1d684612e7.webp",
    "width": 277,
    "height": 235
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": {
    "alt_text": "AXIA RESIDENTIAL BY ARC logo",
    "public_id": "019d54d9-0a7f-7644-86f7-60a98c66fa2f",
    "storage_key": "company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
    "width": 3072,
    "height": 1849
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "AXIA Residential by ARC logo",
    "public_id": "019d54d9-c530-7559-a71a-a1a4613d29fc",
    "storage_key": "company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
    "width": 125,
    "height": 75
  },
  "property_primary_color": "#242424",
  "property_secondary_color": "#373737",
  "property_font_color": "#464646",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "835 - 1480",
  "property_sqft_min": "835",
  "property_sqft_max": "1480",
  "property_price_range": "$1526 - $2246",
  "property_price_min": "1526",
  "property_price_max": "2246",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/LiveatTheJax/",
  "property_instagram_url": "https://www.instagram.com/liveatthejax/",
  "property_twitter_url": "https://x.com/liveatthejax",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJb30URwDR9YgRvtdanfxfloI",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Monroe%2C+GA",
  "property_tiktok_url": "https://www.tiktok.com/@liveatthejax",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Jax",
  "property_home_romance_title": "Embrace a Cozy Life in Your New Apartment Home",
  "property_home_amenities_blurb": "At The Jax in Monroe, GA, experience elevated living with spacious one, two, and three-bedroom apartments. Enjoy resort-style amenities including a shimmering pool, a state-of-the-art fitness center, and a dog park with a wash station. Embrace comfort and style with open-concept designs and modern finishes tailored for your lifestyle.",
  "property_home_floorplans_blurb": "Welcome to The Jax in Monroe, GA, where modern comfort meets stylish living. Choose from our thoughtfully designed one, two, and three-bedroom floor plans tailored to fit your lifestyle. Each space offers a unique ambiance that feels like home. Browse our available apartment homes and find your perfect fit today!",
  "property_home_gallery_blurb": "At The Jax in Monroe, GA, spacious one, two, and three-bedroom apartments await your personal touch. Enjoy resort-style amenities, from a sparkling pool and state-of-the-art fitness center to a welcoming clubhouse. Indulge in serene views and modern comforts, all in a community designed for your extraordinary lifestyle. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At The Jax in Monroe, GA, you'll find spacious one, two, and three-bedroom floor plans surrounded by vibrant local culture. Immerse yourself in community life with attractions like the Monroe Museum, Crispell Park, and educational hubs like Athens Technical College. Dive into an active lifestyle with nearby fitness centers and parks!",
  "property_home_reviews_blurb": "At The Jax in Monroe, GA, residents rave about the vibrant community spirit and exceptional amenities. One resident shares, “Living here feels like home; the staff truly cares!” Experience the warmth and comfort that our residents cherish. Check out their insights and see why The Jax is the perfect choice for you!",
  "property_neighborhood_blurb": "At The Jax in Monroe, GA, vibrant living meets comfort in our thoughtfully designed one-, two-, and three-bedroom apartments. Nestled near parks, educational institutions like Athens Technical College, and community hubs such as the Monroe-Walton County Library, enjoy a lifestyle enriched with convenience and local charm—right at your doorstep!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Experience unparalleled living at The Jax in Monroe, GA, where luxury meets convenience. Enjoy open-concept layouts with stunning granite countertops, paired with exceptional amenities like a resort-style swimming pool, state-of-the-art fitness center, and a vibrant dog park. Your ideal lifestyle awaits—come see what makes us unique!",
  "property_applynow_blurb": "At The Jax in Monroe, GA, find your ideal living space among our thoughtfully designed one, two, and three-bedroom floor plans. Enjoy resort-style amenities, including a shimmering pool, state-of-the-art fitness center, and dog park. Experience modern luxury with granite countertops, hardwood floors, and serene views. Lease online today!",
  "property_contactus_blurb": "At The Jax in Monroe, GA, spacious floor plans await your personalized touch. Choose from stylish one, two, or three-bedroom apartments designed for comfort and convenience. Our dedicated leasing team is ready to assist you with any inquiries you may have. Reach out today and unlock your new apartment lifestyle!",
  "property_faqs_blurb": "At The Jax in Monroe, GA, we offer a range of thoughtfully designed floor plans—one, two, and three bedrooms—to fit your lifestyle. Curious about our vibrant community? Uncover the answers you seek by browsing our Frequently Asked Questions page today, and find the perfect home for you!",
  "property_floorplans_blurb": "At The Jax in Monroe, GA, our thoughtfully designed floor plans cater to your lifestyle, featuring one, two, and three-bedroom options. Embrace comfort and style as you envision your ideal home. Browse our available apartment homes today and let your next chapter unfold in a space that truly resonates with you.",
  "property_gallery_blurb": "At The Jax in Monroe, GA, experience luxurious living with spacious one, two, and three-bedroom floor plans. Indulge in resort-style amenities, from a state-of-the-art fitness center to a serene poolside grill. Picture yourself unwinding in upscale interiors, complete with granite countertops and walk-in closets. Your dream home awaits!",
  "property_interactivemap_blurb": "At The Jax in Monroe, GA, experience open-concept living with stunning views and upscale finishes in one to three-bedroom apartments. Enjoy resort-style amenities like our state-of-the-art fitness center, sparkling pool, and lively clubhouse. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "t The Jax, we believe your pets deserve to feel at home just as much as you do. Our pet-friendly apartment community accommodates up to two pets per home, providing ample space and amenities for your furry companions. From on-site pet washing stations to a playful dog park, our community embraces pet ownership with convenience and care. Please feel free to contact us for full details regarding pet fees, monthly rent, and any additional questions you may have.",
  "property_referafriend_blurb": "At The Jax in Monroe, GA, our vibrant community thrives on connection. Whether you’re in a cozy one-bedroom or spacious three-bedroom, great friends make great neighbors. Share the joy of living here—refer a friend today and build lasting memories together in your new home!",
  "property_residentaccess_blurb": "Welcome to The Jax in Monroe, GA, where comfort meets convenience. Choose from our stylish one, two, or three-bedroom floor plans tailored to your lifestyle. Access your resident portal today to effortlessly pay rent, schedule maintenance, and unlock a world of amenities designed just for you!",
  "property_reviews_blurb": "At The Jax in Monroe, GA, residents rave about their experience, stating, “The community is friendly and the amenities are top-notch!” Join a vibrant neighborhood where comfort and convenience merge seamlessly. Curious about life at The Jax? See what our residents have to say about living at our community!",
  "property_created_at": "1775246916004",
  "property_scheduletour_blurb": "At The Jax in Monroe, GA, choose from cozy one-bedroom retreats to spacious three-bedroom designs, perfectly tailored for every lifestyle. Embrace the community spirit that sets us apart—schedule a tour today and hear firsthand how our residents love calling The Jax home! Your next chapter starts here.",
  "property_thankyou_blurb": "Thank you for reaching out to The Jax in Monroe, GA! Whether you envision a cozy one-bedroom, a spacious two-bedroom, or a sprawling three-bedroom layout, our diverse floor plans cater to every lifestyle. Stay tuned—our team will be in touch shortly to assist you on your journey to your new home!",
  "property_virtualtours_blurb": "At The Jax in Monroe, GA, our thoughtfully designed one, two, and three-bedroom apartments blend comfort and style. Experience vibrant living spaces tailored to your lifestyle. Ready to envision your new home? Take a virtual tour today and see all that our community has to offer!",
  "property_copyright": "2026 All Rights Reserved. The Jax",
  "property_seo_title_home": "The Jax |  Apartments in Monroe, GA",
  "property_seo_description_home": "Experience modern living at The Jax in Monroe, GA. Choose from spacious one to three-bedroom apartments with luxury amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Monroe, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Jax in Monroe, GA. Choose from stylish one, two, or three-bedroom floor plans and enjoy modern living at its finest!",
  "property_seo_title_amenities": "Amenities | Monroe, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at The Jax in Monroe, GA. Enjoy a resort-style pool, modern fitness center, and stylish apartments. Your dream home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Monroe, GA",
  "property_seo_description_gallery": "Discover your ideal lifestyle at The Jax in Monroe, GA, with spacious apartments, luxury amenities, and vibrant community vibes. Envision your new home!",
  "property_seo_title_virtualtours": "Virtual Tours | The Jax Apartments",
  "property_seo_description_virtualtours": "Step inside The Jax in Monroe, GA! Experience our diverse floor plans with a virtual tour—your next home awaits in vibrant comfort and style.",
  "property_seo_title_interactivemap": "Interactive Map | The Jax Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at The Jax in Monroe, GA! Explore spacious floor plans and luxurious amenities with our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Monroe, GA",
  "property_seo_description_neighborhood": "Uncover Monroe's charm at The Jax! From vibrant local spots to hidden gems, dive into the community that surrounds your new home. Adventure awaits!",
  "property_seo_title_contact": "Contact Us | The Jax",
  "property_seo_description_contact": "Uncover your perfect home at The Jax in Monroe, GA. From cozy one-bedrooms to spacious three-bedrooms, our leasing team is here to help—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Monroe, GA",
  "property_seo_description_faqs": "Find answers to your questions about The Jax in Monroe, GA. From spacious floor plans to top-notch amenities, we’ve got you covered. Browse our FAQs!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Monroe, GA",
  "property_seo_description_reviews": "Experience life at The Jax in Monroe, GA! Unwind at our resort-style pool, savor coffee at the bistro, and hear from residents about their vibrant community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Monroe, GA",
  "property_seo_description_applynow": "Experience luxury at The Jax in Monroe, GA! Choose from spacious one, two, or three-bedroom apartments with resort-style amenities. Your ideal home awaits!",
  "property_seo_title_residentaccess": "Resident Access | The Jax",
  "property_seo_description_residentaccess": "Seamlessly manage your life at The Jax! Log in to access rent payments, maintenance requests, and all your resident essentials in one convenient spot.",
  "property_seo_title_referafriend": "Refer A Friend | The Jax",
  "property_seo_description_referafriend": "Refer a friend to The Jax in Monroe, GA! Great friends make great neighbors—share the experience of vibrant living in our welcoming community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Jax",
  "property_seo_description_scheduletour": "Experience modern living at The Jax in Monroe, GA. Schedule a tour today and see why our vibrant community is the perfect place to call home!",
  "property_seo_title_privacy": "Privacy Policy | The Jax",
  "property_seo_description_privacy": "At The Jax in Monroe, GA, your privacy matters. Read our privacy policy to understand how we protect your information while you enjoy our vibrant community.",
  "property_seo_title_accessibility": "Website Accessibility | The Jax",
  "property_seo_description_accessibility": "Experience digital inclusion at The Jax in Monroe, GA. Our commitment ensures everyone can connect and thrive in our vibrant apartment community.",
  "property_seo_title_sitemap": "Sitemap | The Jax",
  "property_seo_description_sitemap": "Uncover every corner of The Jax in Monroe, GA. Navigate our sitemap for a seamless journey through your future home and community amenities.",
  "property_seo_title_thankyou": "Thank You | The Jax",
  "property_seo_description_thankyou": "Thank you for reaching out to The Jax in Monroe, GA! Our team is eager to assist you in finding your perfect home. Stay tuned for a quick response!",
  "property_seo_title_pets": "Pet Policy | Apartments in Monroe, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790793481845",
  "amenities": [
    {
      "id": "custom_27e974f4-bc73-4f41-a3cc-0e65a170bc0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "State of the Art 24hr Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e07e016d-ce0a-4c6c-a464-838b6ee46a45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Poolside Grill",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_48729c51-5181-4c1b-815d-0227ec8b4954",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Luxor One Package Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4e7fb415-361b-4780-8c39-b11d8bcd9289",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "EV Charging Stations",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4628018f-6ca4-4902-875e-248c442b09f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Resort Style Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f1340a0-cfdb-4251-97f5-315cf11af93f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b09d0502-349a-4016-97b6-bad8ade9b453",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse with Gameroom",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_649b5cba-b85f-4de2-a060-0eb9584cbffc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "24 Hour Access and Key Fob Entry",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6c2f769a-3fd1-468a-baaf-29c71834bde7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Complementary Coffee Bistro",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7b5f6174-b131-4aea-bb51-17b726dfa529",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Sand Volleyball Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9f3c0420-ff24-46b4-ba8f-4f316c90275e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Community‑Wide WiFi",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_70ab128b-106a-4948-ba83-dc7511e5e0f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4e77f28b-46d7-4f34-9493-7dd3fd97cc0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Valet Trash Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_53b20304-3b7c-4847-87f2-cb32bf9e1a8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Renters Insurance Program",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f92d7d2-feb5-4ab1-b74c-ecbe0444be0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park with Pet Wash Station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0bd37135-7872-45a2-894a-d5b5fe920f5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Open Concept Living",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02ac3fcf-8f1a-450e-9cce-e99c46b743af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ea2ac4da-ac8c-46b8-99d3-567332d0e61d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Double Pane Windows",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_685e23ec-97d8-436f-80b9-dbf30f1d0551",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af7ba08c-0871-4a6a-9d97-7ac79b20f9e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "9ft High Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5a5d08b2-5022-4f22-b5b6-38dd1f330591",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Large Bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8269866f-f8aa-448f-9c0f-5c63212b34bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c565c68c-ac7e-4702-9c78-ec3e47f7dc5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_51bf2204-e44b-4128-ad5c-bdcef75a10b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7966366a-4e3a-48d2-9aae-f999836a3bef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a6f5ff6c-8e66-41f0-a3b3-bcacfd7a4aa3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6fbcca78-fbd2-4023-a166-e1a815354c0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Serene Views",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95e971d7-63d0-4df3-9707-e7828ee0767a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1d372e5d-011d-4830-bb3e-a2d7b3bacb6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony/Patio",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6bdb6270-d340-4331-b70c-cd719ab55d6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_fa4c48c8-b474-4f76-ae2e-62247810906c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-aa40-75ca-9b7b-794aaf7113f4.webp",
      "image_media": {
        "alt_text": "The Jax luxury apartments monument sign with 'Luxury Apartments Now Leasing' text. Discover apartments for rent in Monroe, GA with online rent payment options at The Jax today.",
        "public_id": "019d7846-aa40-75ca-9b7b-794aaf7113f4",
        "storage_key": "property/6767906449167336/019d7846-aa40-75ca-9b7b-794aaf7113f4.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Welcome to The Jax, luxury apartments now leasing. Discover your new home today.",
      "link": "",
      "alt_text": "The Jax luxury apartments monument sign with 'Luxury Apartments Now Leasing' text. Discover apartments for rent in Monroe, GA with online rent payment options at The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_19c44128-3b17-41f9-b1e8-d499e3a5a889",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-a9a8-7148-a34a-0f9eb9b9c5e6.webp",
      "image_media": {
        "alt_text": "Modern apartment building entrance with stone and brick facade, large windows, and designated parking spaces. Explore apartments near shopping and dining in Monroe, GA at The Jax today.",
        "public_id": "019d7846-a9a8-7148-a34a-0f9eb9b9c5e6",
        "storage_key": "property/6767906449167336/019d7846-a9a8-7148-a34a-0f9eb9b9c5e6.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Welcome to our community's main entrance, featuring a striking stone and brick facade, expansive windows, and convenient, accessible parking.",
      "link": "",
      "alt_text": "Modern apartment building entrance with stone and brick facade, large windows, and designated parking spaces. Explore apartments near shopping and dining in Monroe, GA at The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7371619f-2bb0-4e41-8d28-002f6241844b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-9513-760a-b17e-6517a8eb9205.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a sleek kitchen island, bar stools, and large windows overlooking the pool. Visit The Jax to see gated apartments in Monroe, GA with modern community features.",
        "public_id": "019e02e3-9513-760a-b17e-6517a8eb9205",
        "storage_key": "property/6767906449167336/019e02e3-9513-760a-b17e-6517a8eb9205.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish lounge, featuring a full-service bar, comfortable seating, and stunning views of the resort-style pool. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Modern lounge area with a sleek kitchen island, bar stools, and large windows overlooking the pool. Visit The Jax to see gated apartments in Monroe, GA with modern community features.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8254da5d-0f33-4bb6-919f-e6b1f3111e14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-a804-738b-9b2a-f60aa179a5d3.webp",
      "image_media": {
        "alt_text": "Modern kitchen area with stainless steel appliances, dark cabinetry, and a large window opening to an outdoor seating area. Learn more about apartments near Highway 78 in Monroe, GA at The Jax.",
        "public_id": "019e02e3-a804-738b-9b2a-f60aa179a5d3",
        "storage_key": "property/6767906449167336/019e02e3-a804-738b-9b2a-f60aa179a5d3.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Enjoy our fully equipped kitchen and lounge area, featuring stainless steel appliances, ample counter space, and a unique pass-through window connecting to the outdoor patio. Perfect for entertaining guests or relaxing.",
      "link": "",
      "alt_text": "Modern kitchen area with stainless steel appliances, dark cabinetry, and a large window opening to an outdoor seating area. Learn more about apartments near Highway 78 in Monroe, GA at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4d1a07ce-7657-40c3-acc2-3324bc24e179",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-9476-71f9-a8f0-fa309f78c3f9.webp",
      "image_media": {
        "alt_text": "Free coffee station with a touch screen interface and various coffee options. Explore apartments near shopping and dining in Monroe, GA at The Jax today.",
        "public_id": "019e02e3-9476-71f9-a8f0-fa309f78c3f9",
        "storage_key": "property/6767906449167336/019e02e3-9476-71f9-a8f0-fa309f78c3f9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee from our state-of-the-art coffee station, featuring a variety of premium blends and convenient touchless ordering.",
      "link": "",
      "alt_text": "Free coffee station with a touch screen interface and various coffee options. Explore apartments near shopping and dining in Monroe, GA at The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_40e92e8c-61e7-4f2c-9af2-55222deed77b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-94a7-705b-a8f9-27dd3ebf3181.webp",
      "image_media": {
        "alt_text": "Modern lounge area with fireplace and view of the pool. Tour 2-bedroom apartments in Monroe, GA with washer and dryer features at The Jax.",
        "public_id": "019e02e3-94a7-705b-a8f9-27dd3ebf3181",
        "storage_key": "property/6767906449167336/019e02e3-94a7-705b-a8f9-27dd3ebf3181.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a cozy fireplace and scenic views of the resort-style pool.",
      "link": "",
      "alt_text": "Modern lounge area with fireplace and view of the pool. Tour 2-bedroom apartments in Monroe, GA with washer and dryer features at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9643d191-d163-4a7f-8165-834179d93f50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-973b-74ca-8c54-10be6edf4e04.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating, artwork, and large windows overlooking the pool. Explore apartments in Monroe, GA with pool and fitness center amenities by visiting The Jax today.",
        "public_id": "019e02e3-973b-74ca-8c54-10be6edf4e04",
        "storage_key": "property/6767906449167336/019e02e3-973b-74ca-8c54-10be6edf4e04.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish resident lounge, featuring plush seating, modern decor, and beautiful views of the community pool.",
      "link": "",
      "alt_text": "Modern lounge area with comfortable seating, artwork, and large windows overlooking the pool. Explore apartments in Monroe, GA with pool and fitness center amenities by visiting The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c689c233-174e-4e88-91fa-0d34beaac8f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019df3d0-cbdf-7160-bd67-00c9f6f7b320.webp",
      "image_media": {
        "alt_text": "Lounge area with blue sectional sofa, modern coffee tables, and artwork. Visit The Jax to discover 2-bed apartments in Monroe, GA with updated features.",
        "public_id": "019df3d0-cbdf-7160-bd67-00c9f6f7b320",
        "storage_key": "property/6767906449167336/019df3d0-cbdf-7160-bd67-00c9f6f7b320.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stylish lounge area featuring a curved blue sectional sofa, chic coffee tables, and artistic wall decor, perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Lounge area with blue sectional sofa, modern coffee tables, and artwork. Visit The Jax to discover 2-bed apartments in Monroe, GA with updated features.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e19a96ab-2af6-43b8-b1c7-0ab6a37f3302",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-94b3-75db-9c95-153f73e056b3.webp",
      "image_media": {
        "alt_text": "Modern lounge area with blue sectional sofa, accent chairs, and abstract art. Discover new apartments in Monroe, GA with modern finishes by visiting The Jax.",
        "public_id": "019e02e3-94b3-75db-9c95-153f73e056b3",
        "storage_key": "property/6767906449167336/019e02e3-94b3-75db-9c95-153f73e056b3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating, modern decor, and a welcoming atmosphere.",
      "link": "",
      "alt_text": "Modern lounge area with blue sectional sofa, accent chairs, and abstract art. Discover new apartments in Monroe, GA with modern finishes by visiting The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ddb591aa-cbc7-43ca-9704-41ea4703ad0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-a8cf-72d4-b92e-15e276c685c1.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a large marble fireplace, a TV, and comfortable seating. Discover apartments for rent in Monroe, GA near downtown with a personal tour at The Jax.",
        "public_id": "019e02e3-a8cf-72d4-b92e-15e276c685c1",
        "storage_key": "property/6767906449167336/019e02e3-a8cf-72d4-b92e-15e276c685c1.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax in style in our contemporary lounge area, featuring a striking marble fireplace, a mounted television, and plush seating perfect for unwinding.",
      "link": "",
      "alt_text": "Modern lounge area with a large marble fireplace, a TV, and comfortable seating. Discover apartments for rent in Monroe, GA near downtown with a personal tour at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8dfd75f7-3ce5-4ce5-8cc4-9fb33c4d7b58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019df3d0-a33c-779e-be6a-0e4f56507ce8.webp",
      "image_media": {
        "alt_text": "Modern lounge area with stylish furniture and a view of the pool. Explore Monroe, GA rentals with modern community amenities at The Jax.",
        "public_id": "019df3d0-a33c-779e-be6a-0e4f56507ce8",
        "storage_key": "property/6767906449167336/019df3d0-a33c-779e-be6a-0e4f56507ce8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish resident lounge, featuring comfortable seating and a view of the sparkling pool area. Perfect for socializing or quiet contemplation.",
      "link": "",
      "alt_text": "Modern lounge area with stylish furniture and a view of the pool. Explore Monroe, GA rentals with modern community amenities at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5a00d18d-9e42-4fc1-bcaf-d6c53d9a05b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-9548-77ec-8da7-325f925e9ce6.webp",
      "image_media": {
        "alt_text": "Modern lobby lounge with plush seating, abstract art, and large windows overlooking the pool. Explore 1-bed apartments in Monroe, GA with a tour of The Jax.",
        "public_id": "019e02e3-9548-77ec-8da7-325f925e9ce6",
        "storage_key": "property/6767906449167336/019e02e3-9548-77ec-8da7-325f925e9ce6.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby lounge, featuring comfortable seating, contemporary art, and stunning views of the resort-style pool area.",
      "link": "",
      "alt_text": "Modern lobby lounge with plush seating, abstract art, and large windows overlooking the pool. Explore 1-bed apartments in Monroe, GA with a tour of The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8e66b903-951d-4121-b283-f999d7660c75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-93d2-749e-8cae-d1b5fc39dd02.webp",
      "image_media": {
        "alt_text": "Modern lobby with abstract art and contemporary seating. Contact The Jax to learn more about 3-bedroom apartments in Monroe, GA for rent.",
        "public_id": "019e02e3-93d2-749e-8cae-d1b5fc39dd02",
        "storage_key": "property/6767906449167336/019e02e3-93d2-749e-8cae-d1b5fc39dd02.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome guests into a stylish lobby featuring abstract artwork and chic seating areas. A perfect blend of modern design and comfort.",
      "link": "",
      "alt_text": "Modern lobby with abstract art and contemporary seating. Contact The Jax to learn more about 3-bedroom apartments in Monroe, GA for rent.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6c13ad08-622f-4fee-aad0-afb57686803f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-95b7-70ac-bf61-fa5aaeb27c74.webp",
      "image_media": {
        "alt_text": "Business center with desks and chairs. Learn more about 3-bed apartments in Monroe, GA by touring The Jax today.",
        "public_id": "019e02e3-95b7-70ac-bf61-fa5aaeb27c74",
        "storage_key": "property/6767906449167336/019e02e3-95b7-70ac-bf61-fa5aaeb27c74.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A modern business center with individual desks and comfortable chairs, offering a quiet space for work and productivity.",
      "link": "",
      "alt_text": "Business center with desks and chairs. Learn more about 3-bed apartments in Monroe, GA by touring The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_74ed5679-df76-4d4c-ad5d-549e31b42382",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-c711-77d9-9ceb-41d178688462.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, weight rack, and mirrored walls. Schedule a tour to explore apartments in Monroe, GA near Walton County schools at The Jax.",
        "public_id": "019e02e3-c711-77d9-9ceb-41d178688462",
        "storage_key": "property/6767906449167336/019e02e3-c711-77d9-9ceb-41d178688462.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring treadmills, weight training equipment, and mirrored walls for your workout needs.",
      "link": "",
      "alt_text": "Gym with treadmills, weight rack, and mirrored walls. Schedule a tour to explore apartments in Monroe, GA near Walton County schools at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9f57a9c9-843e-480c-926b-4346f138b78e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019df3d0-ccec-71e1-ba09-f6a53b6c50ff.webp",
      "image_media": {
        "alt_text": "Modern gym with cardio machines, weight machines, free weights, and exercise balls Discover apartments for rent in Monroe, GA by scheduling a personalized tour at The Jax.",
        "public_id": "019df3d0-ccec-71e1-ba09-f6a53b6c50ff",
        "storage_key": "property/6767906449167336/019df3d0-ccec-71e1-ba09-f6a53b6c50ff.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a wide array of cardio equipment, weight machines, free weights, and yoga balls for a complete workout experience.",
      "link": "",
      "alt_text": "Modern gym with cardio machines, weight machines, free weights, and exercise balls Discover apartments for rent in Monroe, GA by scheduling a personalized tour at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_81a26d2b-0f9d-427d-bcf0-059af69142a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-e4b7-70ec-b525-13c927e6ca9f.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical machines, and weightlifting equipment. Contact The Jax to learn more about pet-friendly apartments in Monroe, GA with dog park access.",
        "public_id": "019e02e3-e4b7-70ec-b525-13c927e6ca9f",
        "storage_key": "property/6767906449167336/019e02e3-e4b7-70ec-b525-13c927e6ca9f.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment and a free weights area for residents.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical machines, and weightlifting equipment. Contact The Jax to learn more about pet-friendly apartments in Monroe, GA with dog park access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_31154061-de1a-4f55-aea9-b5b6d2978b2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-d82a-74ed-bda0-7731d51be336.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with cardio machines, weight machines, free weights, and mirrored walls. Explore apartments for rent in Monroe, GA and ask about current availability at The Jax.",
        "public_id": "019e02e3-d82a-74ed-bda0-7731d51be336",
        "storage_key": "property/6767906449167336/019e02e3-d82a-74ed-bda0-7731d51be336.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide array of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Modern apartment gym with cardio machines, weight machines, free weights, and mirrored walls. Explore apartments for rent in Monroe, GA and ask about current availability at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_106961ab-d64f-46ae-9755-a91e641396bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-ef8a-778e-bb10-a7ad0dc97719.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, barbells, dumbbells, and kettlebells. Visit The Jax to discover 2-bed apartments in Monroe, GA.",
        "public_id": "019e02e3-ef8a-778e-bb10-a7ad0dc97719",
        "storage_key": "property/6767906449167336/019e02e3-ef8a-778e-bb10-a7ad0dc97719.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center equipped with weight machines, free weights, and cardio equipment for resident use.",
      "link": "",
      "alt_text": "Fitness center with weight machines, barbells, dumbbells, and kettlebells. Visit The Jax to discover 2-bed apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_050778c0-fa3a-47d1-a097-d6044217f705",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-c7b2-7308-9301-1dbff8bdc56a.webp",
      "image_media": {
        "alt_text": "Treadmills and stair climber in fitness center with view of pool and buildings. Explore apartments for rent in Monroe, GA by scheduling a tour at The Jax.",
        "public_id": "019e02e3-c7b2-7308-9301-1dbff8bdc56a",
        "storage_key": "property/6767906449167336/019e02e3-c7b2-7308-9301-1dbff8bdc56a.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring treadmills, stair climbers, and a view of the resort-style pool.",
      "link": "",
      "alt_text": "Treadmills and stair climber in fitness center with view of pool and buildings. Explore apartments for rent in Monroe, GA by scheduling a tour at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f93f0674-7f01-46e2-a942-ee57598120e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-f605-751c-8039-a2f65858578c.webp",
      "image_media": {
        "alt_text": "Fitness room with exercise balls and resistance bands, overlooking the exterior. Visit The Jax to explore gated apartments in Monroe, GA.",
        "public_id": "019e02e3-f605-751c-8039-a2f65858578c",
        "storage_key": "property/6767906449167336/019e02e3-f605-751c-8039-a2f65858578c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with everything you need for a great workout. Enjoy views of the property grounds while you exercise.",
      "link": "",
      "alt_text": "Fitness room with exercise balls and resistance bands, overlooking the exterior. Visit The Jax to explore gated apartments in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_156d8fff-ebbb-416d-b787-7df9c69fda52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-59e0-7302-8de5-6bded6e366db.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered cabana area, surrounded by apartment buildings. Explore apartments for rent in Monroe, GA, near downtown by scheduling a tour at The Jax today.",
        "public_id": "019e02e4-59e0-7302-8de5-6bded6e366db",
        "storage_key": "property/6767906449167336/019e02e4-59e0-7302-8de5-6bded6e366db.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy our sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded cabana. Perfect for relaxing and socializing.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered cabana area, surrounded by apartment buildings. Explore apartments for rent in Monroe, GA, near downtown by scheduling a tour at The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_56d72f5f-e866-4903-831c-541ba44941fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-5bc7-749b-8162-ca0073027734.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex with a large, sparkling blue swimming pool in the foreground and modern buildings in the background. Tour apartments in Monroe, GA with pool and fitness center amenities at The Jax.",
        "public_id": "019e02e4-5bc7-749b-8162-ca0073027734",
        "storage_key": "property/6767906449167336/019e02e4-5bc7-749b-8162-ca0073027734.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, surrounded by lush landscaping and the beautiful architecture of our apartment community.",
      "link": "",
      "alt_text": "Luxury apartment complex with a large, sparkling blue swimming pool in the foreground and modern buildings in the background. Tour apartments in Monroe, GA with pool and fitness center amenities at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_91a51234-b368-432a-b0d6-ff61fa5b081e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-9afb-731f-8994-88e552a39851.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a swimming pool and lounge area. Contact The Jax to discover 1-bedroom apartments for rent in Monroe, GA.",
        "public_id": "019d7846-9afb-731f-8994-88e552a39851",
        "storage_key": "property/6767906449167336/019d7846-9afb-731f-8994-88e552a39851.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Resort-style swimming pool with lounge chairs and cabana area, surrounded by modern apartment buildings.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a swimming pool and lounge area. Contact The Jax to discover 1-bedroom apartments for rent in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c69474da-d1e3-4019-8d77-141fccdedd1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e2-5a86-747a-bdee-9ca966d6188d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lounge area with apartment buildings in the background. Learn more about pet-friendly apartments in Monroe, GA with dog park amenities at The Jax.",
        "public_id": "019e02e2-5a86-747a-bdee-9ca966d6188d",
        "storage_key": "property/6767906449167336/019e02e2-5a86-747a-bdee-9ca966d6188d.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the pool in our resort-style oasis, surrounded by beautiful apartment homes and lush landscaping.",
      "link": "",
      "alt_text": "Resort-style swimming pool and lounge area with apartment buildings in the background. Learn more about pet-friendly apartments in Monroe, GA with dog park amenities at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b48f4c4e-094f-4420-944c-284e3fad43d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-8e28-73bb-ae61-669ced540cf6.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex featuring a large L-shaped swimming pool and lounge area. Discover 2-bedroom apartments in Monroe, GA with washer and dryer features by touring The Jax.",
        "public_id": "019d7846-8e28-73bb-ae61-669ced540cf6",
        "storage_key": "property/6767906449167336/019d7846-8e28-73bb-ae61-669ced540cf6.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our sparkling swimming pool and ample lounge seating, perfect for relaxing and socializing.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex featuring a large L-shaped swimming pool and lounge area. Discover 2-bedroom apartments in Monroe, GA with washer and dryer features by touring The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_accf20a8-df8d-46cf-96cb-a41195fb4285",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e2-7192-7699-b426-fe885b4ac91d.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas. Explore 1-bed apartments in Monroe, GA by contacting The Jax for more information.",
        "public_id": "019e02e2-7192-7699-b426-fe885b4ac91d",
        "storage_key": "property/6767906449167336/019e02e2-7192-7699-b426-fe885b4ac91d.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by lush landscaping and comfortable seating areas. Perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas. Explore 1-bed apartments in Monroe, GA by contacting The Jax for more information.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8b093dc9-6561-4377-8f07-dc9265e988bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-9a11-7279-84c5-989cbdfff928.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex featuring a swimming pool, lounge area, volleyball court, and outdoor gathering spaces. Learn more about 2-bed apartments in Monroe, GA by contacting The Jax today.",
        "public_id": "019d7846-9a11-7279-84c5-989cbdfff928",
        "storage_key": "property/6767906449167336/019d7846-9a11-7279-84c5-989cbdfff928.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our sparkling swimming pool, relaxing lounge areas, and vibrant outdoor spaces, including a volleyball court and covered seating.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex featuring a swimming pool, lounge area, volleyball court, and outdoor gathering spaces. Learn more about 2-bed apartments in Monroe, GA by contacting The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4ecf81b8-aa66-40f3-9511-1874bb04e0eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-9b23-72bd-a438-6d70bb4662fa.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a large swimming pool, outdoor lounge area, and building exteriors. Discover 1-bed apartments in Monroe, GA with a visit to The Jax.",
        "public_id": "019d7846-9b23-72bd-a438-6d70bb4662fa",
        "storage_key": "property/6767906449167336/019d7846-9b23-72bd-a438-6d70bb4662fa.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Discover the resort-style living at our apartment community, featuring a sparkling swimming pool, spacious sundeck, and comfortable outdoor seating areas.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex with a large swimming pool, outdoor lounge area, and building exteriors. Discover 1-bed apartments in Monroe, GA with a visit to The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4a141be5-583e-4015-9491-53b3122dfc0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e2-8762-71ff-af1f-d025d6139c51.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex amenities including pool, volleyball court, and fire pit. Discover apartments for rent in Monroe, GA with online rent payment options at The Jax.",
        "public_id": "019e02e2-8762-71ff-af1f-d025d6139c51",
        "storage_key": "property/6767906449167336/019e02e2-8762-71ff-af1f-d025d6139c51.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover luxury living with our resort-style pool, sand volleyball court, and outdoor fire pit area. Enjoy the best of community amenities.",
      "link": "",
      "alt_text": "Aerial view of apartment complex amenities including pool, volleyball court, and fire pit. Discover apartments for rent in Monroe, GA with online rent payment options at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eb655f20-8797-4221-be48-a085b29c40cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-5ae5-7592-9627-58b9e58166c9.webp",
      "image_media": {
        "alt_text": "Covered outdoor kitchen with grills and televisions. Explore apartments in Monroe, GA, near Walton County schools with a visit to The Jax.",
        "public_id": "019e02e4-5ae5-7592-9627-58b9e58166c9",
        "storage_key": "property/6767906449167336/019e02e4-5ae5-7592-9627-58b9e58166c9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community's well-equipped outdoor kitchen, complete with grills and televisions for entertainment.",
      "link": "",
      "alt_text": "Covered outdoor kitchen with grills and televisions. Explore apartments in Monroe, GA, near Walton County schools with a visit to The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_52a178b3-5baa-499b-b050-f832ef4b8964",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-5a42-71ce-8050-3c5e463beecd.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with pergola and lounge chairs in front of apartment buildings. Learn more about our pet-friendly apartments in Monroe, GA, by contacting The Jax.",
        "public_id": "019e02e4-5a42-71ce-8050-3c5e463beecd",
        "storage_key": "property/6767906449167336/019e02e4-5a42-71ce-8050-3c5e463beecd.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor seating area, featuring a shaded pergola and comfortable lounge chairs. Enjoy the fresh air and beautiful surroundings of our community.",
      "link": "",
      "alt_text": "Outdoor seating area with pergola and lounge chairs in front of apartment buildings. Learn more about our pet-friendly apartments in Monroe, GA, by contacting The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0c547b8b-8278-47f4-ace4-1185451dc5cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-5bcd-757a-8df3-dbf94e01c1eb.webp",
      "image_media": {
        "alt_text": "Outdoor fire pit area with seating and apartment buildings in the background. See new apartments in Monroe, GA with modern finishes by touring The Jax today.",
        "public_id": "019e02e4-5bcd-757a-8df3-dbf94e01c1eb",
        "storage_key": "property/6767906449167336/019e02e4-5bcd-757a-8df3-dbf94e01c1eb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy cozy evenings around the fire pit in this inviting outdoor community space.",
      "link": "",
      "alt_text": "Outdoor fire pit area with seating and apartment buildings in the background. See new apartments in Monroe, GA with modern finishes by touring The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a797fae-bd0d-4e3c-a5d2-f1d8e54660a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-41e0-771f-8acd-bfdd21b362f1.webp",
      "image_media": {
        "alt_text": "Modern living room with a tan leather sofa, coffee table, and decorative art. Find apartments near Highway 78 in Monroe, GA and contact The Jax for availability details.",
        "public_id": "019e02e4-41e0-771f-8acd-bfdd21b362f1",
        "storage_key": "property/6767906449167336/019e02e4-41e0-771f-8acd-bfdd21b362f1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a tufted tan leather sofa, a rustic wooden coffee table, and tasteful wall art, creating an inviting atmosphere.",
      "link": "",
      "alt_text": "Modern living room with a tan leather sofa, coffee table, and decorative art. Find apartments near Highway 78 in Monroe, GA and contact The Jax for availability details.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_61114ea9-c8e1-4e19-b783-ed4aaf08d09e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019df3d0-b3f1-72d7-b20d-6a530d622a3c.webp",
      "image_media": {
        "alt_text": "Living room with a leather couch, coffee table, and decor. Learn more about 3-bed apartments in Monroe, GA by touring The Jax.",
        "public_id": "019df3d0-b3f1-72d7-b20d-6a530d622a3c",
        "storage_key": "property/6767906449167336/019df3d0-b3f1-72d7-b20d-6a530d622a3c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern and stylish living room featuring a plush leather sofa, a rustic coffee table, and tasteful wall art, creating a cozy and inviting atmosphere.",
      "link": "",
      "alt_text": "Living room with a leather couch, coffee table, and decor. Learn more about 3-bed apartments in Monroe, GA by touring The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d2a62b4e-9804-4d76-b296-aa6348fa9f89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019df3d0-be10-724c-ba5b-576f0de546e0.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living room with granite island, leather sofa, and rustic coffee table. Explore apartments for rent in Monroe, GA with a convenient location at The Jax.",
        "public_id": "019df3d0-be10-724c-ba5b-576f0de546e0",
        "storage_key": "property/6767906449167336/019df3d0-be10-724c-ba5b-576f0de546e0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and stylish open-concept living area featuring a gourmet kitchen with a granite island and a comfortable living room with a leather sofa and unique decor.",
      "link": "",
      "alt_text": "Modern kitchen and living room with granite island, leather sofa, and rustic coffee table. Explore apartments for rent in Monroe, GA with a convenient location at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a0cd73b4-bbfe-4312-9faf-439ae93bc824",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-22c8-72a9-a1a1-fc5bce448407.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops. Learn more about 3-bedroom apartments in Monroe, GA for rent at The Jax.",
        "public_id": "019e02e4-22c8-72a9-a1a1-fc5bce448407",
        "storage_key": "property/6767906449167336/019e02e4-22c8-72a9-a1a1-fc5bce448407.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek stainless steel appliances, crisp white cabinetry, and elegant granite countertops. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops. Learn more about 3-bedroom apartments in Monroe, GA for rent at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92ab3a35-3b1e-4dba-a3d9-b2a19e833c7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019df3d0-ae9d-739f-8067-8676a46fba36.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and island with bar stools. Learn more about apartments in Monroe, GA with a visit to The Jax today.",
        "public_id": "019df3d0-ae9d-739f-8067-8676a46fba36",
        "storage_key": "property/6767906449167336/019df3d0-ae9d-739f-8067-8676a46fba36.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek white cabinetry, elegant granite countertops, and a central island perfect for casual dining or entertaining. Equipped with stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and island with bar stools. Learn more about apartments in Monroe, GA with a visit to The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de502bee-5141-468d-843d-0abdf94c5940",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-24df-731b-9b0b-33e53c9f6399.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertop, sink, and faucet, overlooking a living area. Schedule a visit to explore 2-bedroom apartments for rent in Monroe, GA at The Jax.",
        "public_id": "019e02e4-24df-731b-9b0b-33e53c9f6399",
        "storage_key": "property/6767906449167336/019e02e4-24df-731b-9b0b-33e53c9f6399.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Showcasing a stylish apartment kitchen featuring a granite island, stainless steel sink, and pendant lighting, seamlessly connected to the living room for an open-concept feel.",
      "link": "",
      "alt_text": "Modern kitchen island with granite countertop, sink, and faucet, overlooking a living area. Schedule a visit to explore 2-bedroom apartments for rent in Monroe, GA at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ce4565ec-4aea-44a6-8d34-79e60326d568",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-24a8-764c-bbc9-671d1eeaa2d3.webp",
      "image_media": {
        "alt_text": "Close-up of a black gooseneck kitchen faucet over a granite countertop and sink. Explore apartments near Piedmont Walton Hospital in Monroe, GA by contacting The Jax.",
        "public_id": "019e02e4-24a8-764c-bbc9-671d1eeaa2d3",
        "storage_key": "property/6767906449167336/019e02e4-24a8-764c-bbc9-671d1eeaa2d3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern black gooseneck faucet with a pull-down sprayer, set against a speckled granite countertop in a spacious apartment kitchen.",
      "link": "",
      "alt_text": "Close-up of a black gooseneck kitchen faucet over a granite countertop and sink. Explore apartments near Piedmont Walton Hospital in Monroe, GA by contacting The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_892f6a60-5520-4241-b152-90aafeb465c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-1d45-7007-9a2f-91a7e502f568.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and island seating. Visit The Jax to discover apartments in Monroe, GA with convenient amenities.",
        "public_id": "019e02e4-1d45-7007-9a2f-91a7e502f568",
        "storage_key": "property/6767906449167336/019e02e4-1d45-7007-9a2f-91a7e502f568.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large island with bar stools, sleek white cabinetry, and premium stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and island seating. Visit The Jax to discover apartments in Monroe, GA with convenient amenities.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9e2eedef-0150-49e0-827f-28afde1f0cd0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019df3d0-cdd7-7558-9d71-65e027f09e64.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a king-size bed, dresser, and a comfortable armchair. Schedule a tour to discover 1-bedroom apartments for rent in Monroe, GA at The Jax.",
        "public_id": "019df3d0-cdd7-7558-9d71-65e027f09e64",
        "storage_key": "property/6767906449167336/019df3d0-cdd7-7558-9d71-65e027f09e64.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush king-size bed, elegant decor, and ample natural light. Perfect for relaxation.",
      "link": "",
      "alt_text": "A cozy bedroom with a king-size bed, dresser, and a comfortable armchair. Schedule a tour to discover 1-bedroom apartments for rent in Monroe, GA at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bc419412-5066-42de-a454-d6adc756f06a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-07c8-7359-b3d3-c235a745b221.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, furry throw, and bedside tables. Learn more about 3-bedroom apartments for rent in Monroe, GA at The Jax.",
        "public_id": "019e02e4-07c8-7359-b3d3-c235a745b221",
        "storage_key": "property/6767906449167336/019e02e4-07c8-7359-b3d3-c235a745b221.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed with a luxurious furry throw, complemented by elegant bedside tables and modern decor. Includes an ensuite bathroom.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, furry throw, and bedside tables. Learn more about 3-bedroom apartments for rent in Monroe, GA at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2efc46a1-6fde-4296-b00f-7f88d0514f8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-00cf-708b-bd25-9466a84a20bf.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a large bed, ceiling fan, and large windows. Learn more about Monroe, GA rentals by contacting The Jax today.",
        "public_id": "019e02e4-00cf-708b-bd25-9466a84a20bf",
        "storage_key": "property/6767906449167336/019e02e4-00cf-708b-bd25-9466a84a20bf.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our beautifully designed bedrooms. Featuring a plush bed, modern decor, and ample natural light.",
      "link": "",
      "alt_text": "Stylish bedroom with a large bed, ceiling fan, and large windows. Learn more about Monroe, GA rentals by contacting The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bc0bfa75-13ed-4925-b71f-390fd0416acd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-44c0-76cc-be9f-32ce221cb300.webp",
      "image_media": {
        "alt_text": "Double vanity with granite countertop and white cabinetry. Discover apartments near shopping and dining in Monroe, GA by scheduling a tour at The Jax.",
        "public_id": "019e02e4-44c0-76cc-be9f-32ce221cb300",
        "storage_key": "property/6767906449167336/019e02e4-44c0-76cc-be9f-32ce221cb300.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with ample storage and elegant granite countertops.",
      "link": "",
      "alt_text": "Double vanity with granite countertop and white cabinetry. Discover apartments near shopping and dining in Monroe, GA by scheduling a tour at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_27d2b18c-6746-41a0-a531-20854b2210b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019df3d0-9dcc-709a-96f0-d71715317acc.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dual vanity and a bedroom view. Discover apartments for rent in Monroe, GA near downtown by contacting The Jax today.",
        "public_id": "019df3d0-9dcc-709a-96f0-d71715317acc",
        "storage_key": "property/6767906449167336/019df3d0-9dcc-709a-96f0-d71715317acc.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops and a view into the bedroom.",
      "link": "",
      "alt_text": "Modern bathroom with dual vanity and a bedroom view. Discover apartments for rent in Monroe, GA near downtown by contacting The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0813fba3-f006-4b55-9557-0d436b8c5614",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-54bc-731e-889d-3c5b11f1afc8.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub. Discover 2-bedroom apartments in Monroe, GA with washer and dryer options by visiting The Jax.",
        "public_id": "019e02e4-54bc-731e-889d-3c5b11f1afc8",
        "storage_key": "property/6767906449167336/019e02e4-54bc-731e-889d-3c5b11f1afc8.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Step into a pristine bathroom featuring a sleek vanity, a comfortable toilet, and a relaxing bathtub, perfect for unwinding.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and bathtub. Discover 2-bedroom apartments in Monroe, GA with washer and dryer options by visiting The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ded81dc6-667f-4252-8361-3aa72834e355",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-1595-77bf-ac11-2ddb4d4c06c7.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white subway tile shower and decorative wall art. Tour apartments in Monroe, GA near Athens Technical College at The Jax today.",
        "public_id": "019e02e4-1595-77bf-ac11-2ddb4d4c06c7",
        "storage_key": "property/6767906449167336/019e02e4-1595-77bf-ac11-2ddb4d4c06c7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into a spa-like experience with this sleek bathroom featuring a spacious subway tile shower and elegant decorative accents.",
      "link": "",
      "alt_text": "Modern bathroom with white subway tile shower and decorative wall art. Tour apartments in Monroe, GA near Athens Technical College at The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d3668767-6dad-4388-8b6b-9ba575dd839a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e4-0a86-7576-9fa9-f5882ca3f5b4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity and toilet. Learn more about apartments for rent in Monroe, GA with online rent payment at The Jax.",
        "public_id": "019e02e4-0a86-7576-9fa9-f5882ca3f5b4",
        "storage_key": "property/6767906449167336/019e02e4-0a86-7576-9fa9-f5882ca3f5b4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a granite-top double vanity, a toilet, and a walk-in closet. The flooring is a stylish dark wood-look vinyl plank.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity and toilet. Learn more about apartments for rent in Monroe, GA with online rent payment at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_36910cca-18cd-4892-8fde-b8ee67a6ef69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e3-f9ec-73ef-8deb-2ef9298646bb.webp",
      "image_media": {
        "alt_text": "Washer and dryer in laundry closet. Discover 1-bedroom apartments for rent in Monroe, GA at The Jax today.",
        "public_id": "019e02e3-f9ec-73ef-8deb-2ef9298646bb",
        "storage_key": "property/6767906449167336/019e02e3-f9ec-73ef-8deb-2ef9298646bb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry access.",
      "link": "",
      "alt_text": "Washer and dryer in laundry closet. Discover 1-bedroom apartments for rent in Monroe, GA at The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_64476658-0a95-4b53-9f68-f6c5e734e18c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e2-40e9-76ae-ac7e-0bcd003c5c9f.webp",
      "image_media": {
        "alt_text": "Outdoor dog washing station with grooming tub and waste station. Visit The Jax to explore 2-bedroom apartments in Monroe, GA with washer and dryer features.",
        "public_id": "019e02e2-40e9-76ae-ac7e-0bcd003c5c9f",
        "storage_key": "property/6767906449167336/019e02e2-40e9-76ae-ac7e-0bcd003c5c9f.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Pamper your pet at our convenient outdoor dog washing station, complete with a grooming tub and waste disposal area for easy cleanup.",
      "link": "",
      "alt_text": "Outdoor dog washing station with grooming tub and waste station. Visit The Jax to explore 2-bedroom apartments in Monroe, GA with washer and dryer features.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f1da6d02-3cc3-4eaf-a993-4832727d3c60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-b6bd-748c-9424-043935fe68af.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with multiple buildings arranged around a central courtyard and clubhouse. Visit The Jax to learn more about pet-friendly apartments in Monroe, GA with dog park access.",
        "public_id": "019d7846-b6bd-748c-9424-043935fe68af",
        "storage_key": "property/6767906449167336/019d7846-b6bd-748c-9424-043935fe68af.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Discover this beautiful apartment community featuring modern architecture, ample parking, and lush green spaces. A perfect blend of style and comfort awaits.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex with multiple buildings arranged around a central courtyard and clubhouse. Visit The Jax to learn more about pet-friendly apartments in Monroe, GA with dog park access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_434a07f7-8168-416b-b485-b3c4f8087e75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e2-1b94-73d1-9af1-7f92346e65f1.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with multiple buildings, a central clubhouse, and surrounding landscaping. Contact The Jax to discover 3-bedroom apartments in Monroe, GA for rent.",
        "public_id": "019e02e2-1b94-73d1-9af1-7f92346e65f1",
        "storage_key": "property/6767906449167336/019e02e2-1b94-73d1-9af1-7f92346e65f1.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Sprawling apartment complex featuring contemporary architecture, manicured grounds, and a welcoming central amenity building. Offers a serene living environment.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex with multiple buildings, a central clubhouse, and surrounding landscaping. Contact The Jax to discover 3-bedroom apartments in Monroe, GA for rent.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3921122a-a539-4954-8734-fe0752d48ef3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-a20f-727c-a2c0-45a672f870f3.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with balconies and a parking lot. Learn more about 2-bedroom apartments for rent in Monroe, GA at The Jax today.",
        "public_id": "019d7846-a20f-727c-a2c0-45a672f870f3",
        "storage_key": "property/6767906449167336/019d7846-a20f-727c-a2c0-45a672f870f3.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Exterior view of contemporary apartment buildings featuring balconies, brick accents, and well-maintained landscaping, with a paved parking lot in the foreground.",
      "link": "",
      "alt_text": "Modern apartment buildings with balconies and a parking lot. Learn more about 2-bedroom apartments for rent in Monroe, GA at The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2982e0df-d7c4-4ec1-8268-e92abd39fe96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e2-1bfb-755c-831e-c1e1ac64131a.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with multiple buildings surrounded by trees and a highway in the background. Contact The Jax to learn more about 2-bedroom apartments for rent in Monroe, GA.",
        "public_id": "019e02e2-1bfb-755c-831e-c1e1ac64131a",
        "storage_key": "property/6767906449167336/019e02e2-1bfb-755c-831e-c1e1ac64131a.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Experience comfortable living at this new apartment community, featuring contemporary architecture and a serene setting adjacent to lush greenery.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex with multiple buildings surrounded by trees and a highway in the background. Contact The Jax to learn more about 2-bedroom apartments for rent in Monroe, GA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0f1d4878-d18e-4e20-8e37-22b222992ada",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-ac44-75e2-8e25-9f8ec9697de8.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with grey siding and stone accents, surrounded by green lawn and walking paths. Schedule a tour to discover apartments near Highway 78 in Monroe, GA at The Jax.",
        "public_id": "019d7846-ac44-75e2-8e25-9f8ec9697de8",
        "storage_key": "property/6767906449167336/019d7846-ac44-75e2-8e25-9f8ec9697de8.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Exterior view of new apartment buildings showcasing contemporary architecture, manicured landscaping, and convenient access pathways.",
      "link": "",
      "alt_text": "Modern apartment buildings with grey siding and stone accents, surrounded by green lawn and walking paths. Schedule a tour to discover apartments near Highway 78 in Monroe, GA at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_820b60e3-c4ba-483a-b3a7-f49e1f047b80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-aef9-752d-9c68-a4f22af97bf8.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with balconies and stone accents. Explore apartments in Monroe, GA near Walton County schools with a visit to The Jax today.",
        "public_id": "019d7846-aef9-752d-9c68-a4f22af97bf8",
        "storage_key": "property/6767906449167336/019d7846-aef9-752d-9c68-a4f22af97bf8.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "An aerial view of a contemporary apartment building's exterior, showcasing its multi-level design with balconies, gray siding, and stone detailing.",
      "link": "",
      "alt_text": "Modern apartment building exterior with balconies and stone accents. Explore apartments in Monroe, GA near Walton County schools with a visit to The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8e190711-d9e0-4204-8c8e-f963210f0f44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-ab97-7148-a1dc-625c6011da75.webp",
      "image_media": {
        "alt_text": "Aerial view of modern apartment buildings with a swimming pool and green spaces in the center. Learn more about apartments in Monroe, GA near Athens Technical College by visiting The Jax.",
        "public_id": "019d7846-ab97-7148-a1dc-625c6011da75",
        "storage_key": "property/6767906449167336/019d7846-ab97-7148-a1dc-625c6011da75.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Discover modern living in this vibrant community, featuring a sparkling swimming pool, lush green courtyards, and convenient amenities.",
      "link": "",
      "alt_text": "Aerial view of modern apartment buildings with a swimming pool and green spaces in the center. Learn more about apartments in Monroe, GA near Athens Technical College by visiting The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1d4b5c19-a424-4b96-8c5a-f67f4dbf02fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-aa65-7610-a00e-1ccdb77f735c.webp",
      "image_media": {
        "alt_text": "Outdoor dog park area with a covered picnic shelter and waste station. Discover new apartments in Monroe, GA with modern finishes at The Jax.",
        "public_id": "019d7846-aa65-7610-a00e-1ccdb77f735c",
        "storage_key": "property/6767906449167336/019d7846-aa65-7610-a00e-1ccdb77f735c.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Enjoy our spacious outdoor dog park, perfect for your furry friends to play and socialize. Featuring a covered picnic shelter and convenient waste stations.",
      "link": "",
      "alt_text": "Outdoor dog park area with a covered picnic shelter and waste station. Discover new apartments in Monroe, GA with modern finishes at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f062fa23-dcd7-402e-bd3e-b866624d1c73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-b29d-732e-9d2d-9a317c1d51a6.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with multiple buildings, courtyards, and surrounding greenery. Learn more about apartments in Monroe, GA with pool and fitness center amenities at The Jax.",
        "public_id": "019d7846-b29d-732e-9d2d-9a317c1d51a6",
        "storage_key": "property/6767906449167336/019d7846-b29d-732e-9d2d-9a317c1d51a6.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing the modern architecture and amenities of the apartment community, nestled amidst lush green landscapes.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex with multiple buildings, courtyards, and surrounding greenery. Learn more about apartments in Monroe, GA with pool and fitness center amenities at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6d88d203-7723-46eb-a2b1-ee0046aa81cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e2-5643-767a-a198-0522dbb06dda.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and windows. Tour apartments for rent in Monroe, GA near downtown at The Jax for a closer look.",
        "public_id": "019e02e2-5643-767a-a198-0522dbb06dda",
        "storage_key": "property/6767906449167336/019e02e2-5643-767a-a198-0522dbb06dda.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Showcasing the modern architecture of this apartment building, featuring spacious balconies and large windows for ample natural light.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies and windows. Tour apartments for rent in Monroe, GA near downtown at The Jax for a closer look.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aa6a4932-f1e2-49a0-907d-939428258389",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e2-1b6a-740c-b77b-6a5bc324a2e5.webp",
      "image_media": {
        "alt_text": "Aerial view of a fenced-in dog park area adjacent to apartment buildings and a parking lot. Discover 2-bed apartments in Monroe, GA with a tour of The Jax today.",
        "public_id": "019e02e2-1b6a-740c-b77b-6a5bc324a2e5",
        "storage_key": "property/6767906449167336/019e02e2-1b6a-740c-b77b-6a5bc324a2e5.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy our spacious, fenced-in dog park, perfect for your furry friends to play and socialize. Located conveniently near our apartment buildings and ample parking.",
      "link": "",
      "alt_text": "Aerial view of a fenced-in dog park area adjacent to apartment buildings and a parking lot. Discover 2-bed apartments in Monroe, GA with a tour of The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d1660cbf-3759-4d9f-bd10-c5933f6df3ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-895e-70eb-ad22-299c31d4e35e.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex courtyard with volleyball court and fire pit area. Explore apartments near Highway 78 in Monroe, GA by scheduling a tour at The Jax.",
        "public_id": "019d7846-895e-70eb-ad22-299c31d4e35e",
        "storage_key": "property/6767906449167336/019d7846-895e-70eb-ad22-299c31d4e35e.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation and relaxation in our community courtyard, featuring a sand volleyball court and a cozy fire pit area.",
      "link": "",
      "alt_text": "Aerial view of apartment complex courtyard with volleyball court and fire pit area. Explore apartments near Highway 78 in Monroe, GA by scheduling a tour at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1bc6cedd-3bfa-426b-8598-ab957f4572c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-9b11-7578-8285-163e7e2ae6d9.webp",
      "image_media": {
        "alt_text": "Covered outdoor seating area with picnic tables and mailboxes. Discover apartments for rent in Monroe, GA with flexible floor plan options at The Jax.",
        "public_id": "019d7846-9b11-7578-8285-163e7e2ae6d9",
        "storage_key": "property/6767906449167336/019d7846-9b11-7578-8285-163e7e2ae6d9.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Enjoy our community's outdoor amenities, including a covered picnic area and convenient mail delivery.",
      "link": "",
      "alt_text": "Covered outdoor seating area with picnic tables and mailboxes. Discover apartments for rent in Monroe, GA with flexible floor plan options at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_85ecac25-0995-4294-a4d5-12168848e6f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e2-4540-7248-a926-f2c17441ad96.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and large windows. Tour new apartments in Monroe, GA with modern finishes by scheduling a visit to The Jax.",
        "public_id": "019e02e2-4540-7248-a926-f2c17441ad96",
        "storage_key": "property/6767906449167336/019e02e2-4540-7248-a926-f2c17441ad96.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover comfortable living in this modern apartment building, featuring private balconies and spacious windows that let in natural light.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies and large windows. Tour new apartments in Monroe, GA with modern finishes by scheduling a visit to The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7562a60f-467b-40d6-9966-c98d5b227763",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e2-8240-73e6-a464-f224755e3726.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with brick and siding exteriors and balconies. Schedule a visit to explore apartments near Piedmont Walton Hospital in Monroe, GA at The Jax.",
        "public_id": "019e02e2-8240-73e6-a464-f224755e3726",
        "storage_key": "property/6767906449167336/019e02e2-8240-73e6-a464-f224755e3726.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover resort-style living in these modern apartment buildings, featuring elegant brick and siding exteriors and private balconies.",
      "link": "",
      "alt_text": "Modern apartment buildings with brick and siding exteriors and balconies. Schedule a visit to explore apartments near Piedmont Walton Hospital in Monroe, GA at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_db8cf9e9-c6ce-4522-9c88-b90523732f26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e2-838f-7796-b79d-efc7fa6efee3.webp",
      "image_media": {
        "alt_text": "Apartment complex courtyard with pool and volleyball court. Tour 1-bedroom apartments for rent in Monroe, GA at The Jax today.",
        "public_id": "019e02e2-838f-7796-b79d-efc7fa6efee3",
        "storage_key": "property/6767906449167336/019e02e2-838f-7796-b79d-efc7fa6efee3.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation at our resort-style community, featuring a sparkling pool and a sand volleyball court, perfect for staying active and socializing.",
      "link": "",
      "alt_text": "Apartment complex courtyard with pool and volleyball court. Tour 1-bedroom apartments for rent in Monroe, GA at The Jax today.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0d124fd-884e-4cde-9a06-cbda5b95b1ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019e02e2-8aab-763a-bc2e-ac3644c88f87.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex with multiple buildings, parking lots, and a swimming pool. Learn more about 3-bedroom apartments for rent in Monroe, GA by visiting The Jax.",
        "public_id": "019e02e2-8aab-763a-bc2e-ac3644c88f87",
        "storage_key": "property/6767906449167336/019e02e2-8aab-763a-bc2e-ac3644c88f87.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Spacious apartment community featuring modern buildings, ample parking, and resort-style amenities including an outdoor swimming pool.",
      "link": "",
      "alt_text": "Aerial view of an apartment complex with multiple buildings, parking lots, and a swimming pool. Learn more about 3-bedroom apartments for rent in Monroe, GA by visiting The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_338d4f85-4c33-4ee8-913a-dac3194945c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-96ea-72ae-8357-f1f6e3027dd3.webp",
      "image_media": {
        "alt_text": "Exterior view of modern apartment buildings with balconies and stone accents. Learn more about apartments for rent in Monroe, GA near downtown with a tour of The Jax.",
        "public_id": "019d7846-96ea-72ae-8357-f1f6e3027dd3",
        "storage_key": "property/6767906449167336/019d7846-96ea-72ae-8357-f1f6e3027dd3.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Welcome to our community featuring beautifully designed apartment buildings with private balconies and elegant stone accents, creating a sophisticated living environment.",
      "link": "",
      "alt_text": "Exterior view of modern apartment buildings with balconies and stone accents. Learn more about apartments for rent in Monroe, GA near downtown with a tour of The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d3dc7d90-7cf8-4214-afc8-446397e41c94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d7846-8925-751f-8275-942a681f56d3.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and a paved walkway. Learn more about apartments in Monroe, GA with pool and fitness center access at The Jax.",
        "public_id": "019d7846-8925-751f-8275-942a681f56d3",
        "storage_key": "property/6767906449167336/019d7846-8925-751f-8275-942a681f56d3.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Showcasing the contemporary architecture of our apartment building, complete with private balconies and well-maintained grounds. A perfect place to call home.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies and a paved walkway. Learn more about apartments in Monroe, GA with pool and fitness center access at The Jax.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_829f8d2c-25eb-41ab-bdca-a8dac44741dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "620 GA-138, Monroe, GA 30655, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves fresh, hot food, including chicken sandwiches, nuggets, and waffle fries. They highlight the fast service and friendly staff. They also like the convenient drive-thru and mobile app ordering.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-4574-710a-98b3-ea6c7b4da5a7.webp",
      "poi_featured_image_media": {
        "alt_text": "Dining area with booths, tables, and chairs, including a high chair.",
        "public_id": "019d54f6-4574-710a-98b3-ea6c7b4da5a7",
        "storage_key": "property/6767906449167336/019d54f6-4574-710a-98b3-ea6c7b4da5a7.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ga/monroe-ga?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8940932553396065646&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "33.7958236",
      "poi_longitude": "-83.7413011",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-266-0211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f2f-75d0-9099-631508c58629.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54f7-1f2f-75d0-9099-631508c58629",
        "storage_key": "property/6767906449167336/019d54f7-1f2f-75d0-9099-631508c58629.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOVxTwifQ9YgRbhXmRcmSFHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_0f2a3f4c-6761-417f-886e-cd3e22a47ac3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Le Gabrielle Crepes & Waffles",
      "poi_type": "Restaurants",
      "poi_address": "125 N Wayne St, Monroe, GA 30655, USA",
      "poi_short_description": "Elegant eatery featuring an assortment of sweet and savory crepes, plus a brunch menu.",
      "poi_long_description": "People say this restaurant serves delicious crepes, waffles, and breakfast items, including shrimp and grits, lobster and shrimp crepes, and eggs Benedict. They highlight the flavorful food, generous portions, and fresh ingredients. They also like the attentive service and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-449a-722d-9e53-7cebe6d195a1.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior dining area with booths and wooden accent wall.",
        "public_id": "019d54f6-449a-722d-9e53-7cebe6d195a1",
        "storage_key": "property/6767906449167336/019d54f6-449a-722d-9e53-7cebe6d195a1.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "https://www.legabrielle.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2204938322237566825&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "le-gabrielle-crepes--waffles",
      "poi_latitude": "33.7953923",
      "poi_longitude": "-83.714343",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 706-395-8996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f2f-75d0-9099-631508c58629.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54f7-1f2f-75d0-9099-631508c58629",
        "storage_key": "property/6767906449167336/019d54f7-1f2f-75d0-9099-631508c58629.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQA0O_LR9YgRaa-dyLiDmR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_eb2e67f4-625f-47ad-ac32-729979ccec74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Huey Magoo's Chicken Tenders",
      "poi_type": "Restaurants",
      "poi_address": "601 Pavilion Pkwy, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "Diners say this chicken restaurant serves up delicious chicken tenders with a variety of sauces, including the Huey and honey mustard, and tasty fries. They also highlight the friendly and helpful staff, and the clean and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-4579-73d8-b14b-ca499e51e8aa.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Huey Magoo's restaurant with outdoor seating and signage.",
        "public_id": "019d54f6-4579-73d8-b14b-ca499e51e8aa",
        "storage_key": "property/6767906449167336/019d54f6-4579-73d8-b14b-ca499e51e8aa.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "https://hueymagoos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11999474812673625527&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "huey-magoos-chicken-tenders",
      "poi_latitude": "33.8061891",
      "poi_longitude": "-83.7342834",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 470-504-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f2f-75d0-9099-631508c58629.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54f7-1f2f-75d0-9099-631508c58629",
        "storage_key": "property/6767906449167336/019d54f7-1f2f-75d0-9099-631508c58629.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxUiMYwDR9YgRt42oJMSyhqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_5450be81-f6f0-44a6-9836-00c7abd3acb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Tokyo Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "250 M.L.K. Jr Blvd, Monroe, GA 30655, USA",
      "poi_short_description": "Traditional Japanese fare including sushi, steak, chicken and shrimp cooked at hibachi grills in a spacious, casual setting, plus fried rice and bento boxes.",
      "poi_long_description": "People say this Japanese restaurant serves delicious hibachi, sushi, and steak. They also highlight the generous portions, reasonable prices, and clean atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-5758-722d-ae2e-bb75a7b1c569.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Tokyo Hibachi & Sushi restaurant with a large sign.",
        "public_id": "019d54f6-5758-722d-ae2e-bb75a7b1c569",
        "storage_key": "property/6767906449167336/019d54f6-5758-722d-ae2e-bb75a7b1c569.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.tokyomonroega.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=600243428095237353&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tokyo-restaurant",
      "poi_latitude": "33.7922464",
      "poi_longitude": "-83.7459284",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-207-1134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f2f-75d0-9099-631508c58629.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54f7-1f2f-75d0-9099-631508c58629",
        "storage_key": "property/6767906449167336/019d54f7-1f2f-75d0-9099-631508c58629.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ83zVphbQ9YgR6Rxhtjd-VAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_5bbd41e7-d618-463a-9578-6d957ec22167",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "185 M.L.K. Jr Blvd, Monroe, GA 30655, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, salads, and burgers. They also highlight the attentive service and great atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-93ee-7609-9611-1a9b41c0aaed.webp",
      "poi_featured_image_media": {
        "alt_text": "Longhorn Steakhouse building exterior with parking lot and cars.",
        "public_id": "019d54f6-93ee-7609-9611-1a9b41c0aaed",
        "storage_key": "property/6767906449167336/019d54f6-93ee-7609-9611-1a9b41c0aaed.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/ga/monroe/monroe-ga/5329?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:monroe-ga-5329_pl:locurl_rd:1276",
      "poi_directions_map_url": "https://maps.google.com/?cid=7750367235509798366&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "33.793217",
      "poi_longitude": "-83.743434",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-266-5620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f2f-75d0-9099-631508c58629.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d54f7-1f2f-75d0-9099-631508c58629",
        "storage_key": "property/6767906449167336/019d54f7-1f2f-75d0-9099-631508c58629.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ31abaWvQ9YgR3kVj_-_Vjms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_0d88007f-d9af-4dfa-9268-4bca269ffc65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Publix Super Market at Monroe Pavilion",
      "poi_type": "Shopping & Retail",
      "poi_address": "900 Pavilion Pkwy, Monroe, GA 30656, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this supermarket offers fresh produce, good meats, and a wide selection of products, including sandwiches and subs. They highlight the clean and organized store, and the friendly and helpful staff. They also like the convenient location and easy access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-44fe-7107-af82-d08549f8dc3b.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Publix grocery store with cars in the parking lot.",
        "public_id": "019d54f6-44fe-7107-af82-d08549f8dc3b",
        "storage_key": "property/6767906449167336/019d54f6-44fe-7107-af82-d08549f8dc3b.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1736&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=16893290165041585487&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-monroe-pavilion",
      "poi_latitude": "33.8055585",
      "poi_longitude": "-83.7322197",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-635-4316",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f2f-75d0-9099-6b24ec728207.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54f7-1f2f-75d0-9099-6b24ec728207",
        "storage_key": "property/6767906449167336/019d54f7-1f2f-75d0-9099-6b24ec728207.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo4t2BFLR9YgRT13njuYFceo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_befd2ced-2d88-40d8-8ce5-bee5b8b6f8c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2150 W Spring St, Monroe, GA 30655, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-4403-723f-be9b-5fffb14ae040.webp",
      "poi_featured_image_media": {
        "alt_text": "The Home Depot logo and storefront with plants and shopping carts outside.",
        "public_id": "019d54f6-4403-723f-be9b-5fffb14ae040",
        "storage_key": "property/6767906449167336/019d54f6-4403-723f-be9b-5fffb14ae040.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Monroe/GA/Monroe/30655/1774?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=608132416200285722&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.8008884",
      "poi_longitude": "-83.74510529999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-266-0550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f3a-7522-b1db-dcc5f20aaf70.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54f7-1f3a-7522-b1db-dcc5f20aaf70",
        "storage_key": "property/6767906449167336/019d54f7-1f3a-7522-b1db-dcc5f20aaf70.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ83zVphbQ9YgRGp4E5DWFcAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_93fb196e-4766-47b4-ba87-688931523525",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "812 Pavilion Pkwy, Monroe, GA 30656, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-58e0-768a-8315-3c29cd9307cf.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of Ross Dress for Less store at dusk with a colorful sky",
        "public_id": "019d54f6-58e0-768a-8315-3c29cd9307cf",
        "storage_key": "property/6767906449167336/019d54f6-58e0-768a-8315-3c29cd9307cf.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9369794830412614961&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "33.8060182",
      "poi_longitude": "-83.7305392",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 943-234-0364",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f3a-7522-b1db-dcc5f20aaf70.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54f7-1f3a-7522-b1db-dcc5f20aaf70",
        "storage_key": "property/6767906449167336/019d54f7-1f3a-7522-b1db-dcc5f20aaf70.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE3-og2bR9YgRMQ0JRcEyCII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_fa6764ef-6ce5-4ff1-b81e-4d5a424c6106",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "John's Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "416 S Broad St, Monroe, GA 30655, USA",
      "poi_short_description": "Clean family-owned grocery chain featuring steaks, beer and baked goods , plus a deli.",
      "poi_long_description": "People say this supermarket offers a wide selection of fresh meat, produce, and locally baked goods. They highlight the great prices, especially on meat, and the small-town atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-4456-715f-bf08-8c5b6ca92200.webp",
      "poi_featured_image_media": {
        "alt_text": "John's Supermarket building exterior with two people walking in front.",
        "public_id": "019d54f6-4456-715f-bf08-8c5b6ca92200",
        "storage_key": "property/6767906449167336/019d54f6-4456-715f-bf08-8c5b6ca92200.webp",
        "width": 680,
        "height": 453
      },
      "poi_business_url": "https://johnsmonroe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1339491501350996&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "johns-supermarket",
      "poi_latitude": "33.7892827",
      "poi_longitude": "-83.7118796",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-267-5632",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f2f-75d0-9099-6b24ec728207.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d54f7-1f2f-75d0-9099-6b24ec728207",
        "storage_key": "property/6767906449167336/019d54f7-1f2f-75d0-9099-6b24ec728207.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqRj5VPLQ9YgRVCAeq0LCBAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_01fe2d29-6bab-47b5-b62b-3d2b85d57c7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "The Story Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "124 N Broad St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this children's bookstore is magical, with fun decorations and details to explore, as well as a great selection of books. They also highlight the friendly, helpful, and engaging staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-60c6-715e-8f83-bee57b7367dc.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of The Story Shop, a children's bookstore, with its entrance and signage.",
        "public_id": "019d54f6-60c6-715e-8f83-bee57b7367dc",
        "storage_key": "property/6767906449167336/019d54f6-60c6-715e-8f83-bee57b7367dc.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.visitthestoryshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10692205917331774913&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-story-shop",
      "poi_latitude": "33.7955833",
      "poi_longitude": "-83.7130856",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-635-8801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f3a-7522-b1db-dcc5f20aaf70.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d54f7-1f3a-7522-b1db-dcc5f20aaf70",
        "storage_key": "property/6767906449167336/019d54f7-1f3a-7522-b1db-dcc5f20aaf70.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJN4Z5X4zQ9YgRwd3jz6FYYpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_5869aedb-2be2-4702-840b-36136cca1ecf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "George Walton Academy",
      "poi_type": "Education",
      "poi_address": "1 Bulldog Dr, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-7265-743f-961f-41acc7ebf5fa.webp",
      "poi_featured_image_media": {
        "alt_text": "Brick building with a clock tower and a bell.",
        "public_id": "019d54f6-7265-743f-961f-41acc7ebf5fa",
        "storage_key": "property/6767906449167336/019d54f6-7265-743f-961f-41acc7ebf5fa.webp",
        "width": 1424,
        "height": 700
      },
      "poi_business_url": "http://www.gwa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17307386663454790617&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "george-walton-academy",
      "poi_latitude": "33.7897801",
      "poi_longitude": "-83.74006849999999",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-635-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f5c-735b-bd5b-e5a9f0807a86.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f7-1f5c-735b-bd5b-e5a9f0807a86",
        "storage_key": "property/6767906449167336/019d54f7-1f5c-735b-bd5b-e5a9f0807a86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcXUPikDQ9YgR2VOO0XgwMPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_74027a1b-3ebd-4fb3-8fe6-a87d733ecf45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Athens Technical College - Monroe Campus",
      "poi_type": "Education",
      "poi_address": "212 Bryant Rd, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-72c2-70de-bec9-39c541abaa57.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with large trees and grassy common areas.",
        "public_id": "019d54f6-72c2-70de-bec9-39c541abaa57",
        "storage_key": "property/6767906449167336/019d54f6-72c2-70de-bec9-39c541abaa57.webp",
        "width": 1170,
        "height": 820
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5990230688498625540&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "athens-technical-college---monroe-campus",
      "poi_latitude": "33.8028809",
      "poi_longitude": "-83.7062133",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 706-552-0901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f5c-735b-bd5b-e5a9f0807a86.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f7-1f5c-735b-bd5b-e5a9f0807a86",
        "storage_key": "property/6767906449167336/019d54f7-1f5c-735b-bd5b-e5a9f0807a86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0dja7ZDQ9YgRBKya1hKTIVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_11aba3b6-deba-47fe-a81e-f05421b6b35e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Monroe-Walton County Library",
      "poi_type": "Education",
      "poi_address": "217 W Spring St, Monroe, GA 30655, USA",
      "poi_short_description": "Part of a 9-member library system, this facility features programs and Wi-Fi, plus kid-friendly activities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-77bb-779d-8c92-046c12ce9093.webp",
      "poi_featured_image_media": {
        "alt_text": "Children's library area with books, tables, chairs, and alphabet rug.",
        "public_id": "019d54f6-77bb-779d-8c92-046c12ce9093",
        "storage_key": "property/6767906449167336/019d54f6-77bb-779d-8c92-046c12ce9093.webp",
        "width": 3072,
        "height": 2101
      },
      "poi_business_url": "https://www.azalealibraries.org/mr-county-library",
      "poi_directions_map_url": "https://maps.google.com/?cid=15463186361171355133&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "monroe-walton-county-library",
      "poi_latitude": "33.79405",
      "poi_longitude": "-83.7155444",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-267-4630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f5c-735b-bd5b-e5a9f0807a86.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d54f7-1f5c-735b-bd5b-e5a9f0807a86",
        "storage_key": "property/6767906449167336/019d54f7-1f5c-735b-bd5b-e5a9f0807a86.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYSXrZovQ9YgR_aVIaRFGmNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_7345a1d0-27ae-4d29-be06-26725e86b771",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "McDaniel-Tichenor House",
      "poi_type": "Entertainment",
      "poi_address": "319 McDaniel St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-7f27-762a-a21a-a69d40f4581c.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a large, historic brick building with white columns and shutters.",
        "public_id": "019d54f6-7f27-762a-a21a-a69d40f4581c",
        "storage_key": "property/6767906449167336/019d54f6-7f27-762a-a21a-a69d40f4581c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.mcdaniel-tichenor.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10348970228384900184&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mcdaniel-tichenor-house",
      "poi_latitude": "33.7907802",
      "poi_longitude": "-83.715887",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-267-5602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqZatl_TQ9YgRWKT5bZftno8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_b63cfef8-710c-4fbe-8b82-6146e9671d88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Monroe Museum",
      "poi_type": "Entertainment",
      "poi_address": "227 S Broad St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-789c-777f-916e-dcdaad420fa6.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of City Hall building with \"Monroe Museum\" and \"Monroe Visitors Center\" signs visible.",
        "public_id": "019d54f6-789c-777f-916e-dcdaad420fa6",
        "storage_key": "property/6767906449167336/019d54f6-789c-777f-916e-dcdaad420fa6.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://monroegamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3641994151141530450&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "monroe-museum",
      "poi_latitude": "33.79277980000001",
      "poi_longitude": "-83.7124828",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-635-8997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f4c-73ba-a261-5f71c0fed867.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with letter M inside",
        "public_id": "019d54f7-1f4c-73ba-a261-5f71c0fed867",
        "storage_key": "property/6767906449167336/019d54f7-1f4c-73ba-a261-5f71c0fed867.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6ra0ozQ9YgRUlvXZGL2ijI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e75d5035-6f0f-4041-863f-a7024ca0b1af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Hurricane Stadium",
      "poi_type": "Entertainment",
      "poi_address": "300 Double Springs Church Rd, Monroe, GA 30656, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-8f2b-75a9-ad5e-dd23cece3f8e.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of a football stadium with a turf field and bleachers.",
        "public_id": "019d54f6-8f2b-75a9-ad5e-dd23cece3f8e",
        "storage_key": "property/6767906449167336/019d54f6-8f2b-75a9-ad5e-dd23cece3f8e.webp",
        "width": 1240,
        "height": 827
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12652415307219586032&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hurricane-stadium",
      "poi_latitude": "33.8207468",
      "poi_longitude": "-83.73594729999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f5c-735b-bd5b-ea6ae72f752a.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized illustration of two people sitting at a table.",
        "public_id": "019d54f7-1f5c-735b-bd5b-ea6ae72f752a",
        "storage_key": "property/6767906449167336/019d54f7-1f5c-735b-bd5b-ea6ae72f752a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF2GICMzb9YgR8MuJwa9olq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_683eea25-34aa-4e16-b62b-e83e1e9f77e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "614 Pavilion Pkwy, Monroe, GA 30655, USA",
      "poi_short_description": "Clean and spacious gym, offering tanning beds and a spa area.",
      "poi_long_description": "People say this gym offers a wide variety of clean and well-maintained equipment, including cardio machines and resistance training options. They highlight the affordable membership, the \"Judgment Free Zone\" atmosphere, and the consistently tidy facilities. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-9904-738a-83db-f3b0fd5dde15.webp",
      "poi_featured_image_media": {
        "alt_text": "People working out in a large gym with purple and yellow equipment.",
        "public_id": "019d54f6-9904-738a-83db-f3b0fd5dde15",
        "storage_key": "property/6767906449167336/019d54f6-9904-738a-83db-f3b0fd5dde15.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/monroe-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=443228685998644277&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.806929",
      "poi_longitude": "-83.72908319999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 470-758-4490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1aBAOy3R9YgRNVw2PySqJgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8312381a-a4ed-449a-9373-f8db3a24f11f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Salon 124 Monroe",
      "poi_type": "Health and Wellness",
      "poi_address": "134 N Broad St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-9aef-768b-82fd-2e271b4ecec3.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a brick building with \"SALON 124\" signage, awnings, and street-level windows.",
        "public_id": "019d54f6-9aef-768b-82fd-2e271b4ecec3",
        "storage_key": "property/6767906449167336/019d54f6-9aef-768b-82fd-2e271b4ecec3.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://salon124.com/locations/monroe/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15146349093217869801&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salon-124-monroe",
      "poi_latitude": "33.7958307",
      "poi_longitude": "-83.71308479999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-905-9909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ194CKB3R9YgR6Z9PYUCkMtI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_5f630095-930a-4f62-809d-6996ea3d161a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Brown Veterinary Services and Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2120 W Spring St Suite 1000, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-a772-70bd-a8cc-d1dc44777120.webp",
      "poi_featured_image_media": {
        "alt_text": "Brown Veterinary Services logo with various animals.",
        "public_id": "019d54f6-a772-70bd-a8cc-d1dc44777120",
        "storage_key": "property/6767906449167336/019d54f6-a772-70bd-a8cc-d1dc44777120.webp",
        "width": 1024,
        "height": 1536
      },
      "poi_business_url": "http://www.brownveterinary.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1824240269449487115&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brown-veterinary-services-and-urgent-care",
      "poi_latitude": "33.79893120000001",
      "poi_longitude": "-83.7446071",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 678-464-1712",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJseg3L4qM9ogRC-N_HdwAURk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_5bf25768-57e5-4aab-8de3-299403722e6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Walton Athletic 24",
      "poi_type": "Health and Wellness",
      "poi_address": "1205 W Spring St, Monroe, GA 30655, USA",
      "poi_short_description": "Fitness center offering weight training, aerobics classes, swimming, and massage therapy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-9a39-73fb-87f6-bbf05566856b.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Walton Athletic 24 gym with a parking lot in front.",
        "public_id": "019d54f6-9a39-73fb-87f6-bbf05566856b",
        "storage_key": "property/6767906449167336/019d54f6-9a39-73fb-87f6-bbf05566856b.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://waltonathletic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=208760771383019720&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "walton-athletic-24",
      "poi_latitude": "33.7909258",
      "poi_longitude": "-83.7326473",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-267-0031",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN202JELQ9YgRyEhSxdCq5QI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dc26caed-9c8c-4737-bcba-adf57464710a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Monroe Fit Body Boot Camp",
      "poi_type": "Health and Wellness",
      "poi_address": "134 M.L.K. Jr Blvd, Monroe, GA 30655, USA",
      "poi_short_description": "Affordable fitness venue, with 30-minute workout classes held for all levels.",
      "poi_long_description": "People say this fitness center offers challenging and diverse workouts that change daily. They highlight the welcoming and friendly atmosphere, and the knowledgeable and encouraging coaches. They also like the supportive community and the availability of childcare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-ac95-7281-af4b-5ab7b045de61.webp",
      "poi_featured_image_media": {
        "alt_text": "Two women in M&M themed outfits in a gym",
        "public_id": "019d54f6-ac95-7281-af4b-5ab7b045de61",
        "storage_key": "property/6767906449167336/019d54f6-ac95-7281-af4b-5ab7b045de61.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://fitbodybootcamp.com/666-monroe-ga/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15820878475568295738&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "monroe-fit-body-boot-camp",
      "poi_latitude": "33.7948975",
      "poi_longitude": "-83.74474239999999",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 470-948-8870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt0vWSKHR9YgROi_foiYNj9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_0a80c4a7-42ba-4bd2-b434-1e20b8006600",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Monroe Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "823 E Spring St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-a833-76f8-8552-5e225b27b6e7.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Country Dog property with a red door and 'Country Dog' sign.",
        "public_id": "019d54f6-a833-76f8-8552-5e225b27b6e7",
        "storage_key": "property/6767906449167336/019d54f6-a833-76f8-8552-5e225b27b6e7.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "http://www.monroevet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2124988208752377143&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "monroe-veterinary-clinic",
      "poi_latitude": "33.8008507",
      "poi_longitude": "-83.70202019999999",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-267-3690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa5jguJfQ9YgRNz2UZoR5fR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_de058fca-95f6-41da-9f98-874f6a556747",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Monroe Animal Care Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "210 W Spring St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-b37f-7731-92bb-61f1db1242f1.webp",
      "poi_featured_image_media": {
        "alt_text": "Veterinary clinic examination room with cages and medical equipment.",
        "public_id": "019d54f6-b37f-7731-92bb-61f1db1242f1",
        "storage_key": "property/6767906449167336/019d54f6-b37f-7731-92bb-61f1db1242f1.webp",
        "width": 1500,
        "height": 1000
      },
      "poi_business_url": "http://www.monroeanimal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15092087133789937902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "monroe-animal-care-hospital",
      "poi_latitude": "33.794654",
      "poi_longitude": "-83.71578799999999",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-267-3006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSXrZovQ9YgR7uDKcEndcdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_66720e0a-7d28-4fa2-ba4f-44d529ee58e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Freddy’s BarberShop",
      "poi_type": "Health and Wellness",
      "poi_address": "214 M.L.K. Jr Blvd, Monroe, GA 30655, USA",
      "poi_short_description": "Buzz-cut to beard trim shop, with friendly service, that also caters to kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-b5f2-723d-80b7-1a3347681e4b.webp",
      "poi_featured_image_media": {
        "alt_text": "Barber giving a young boy a haircut in a barber shop.",
        "public_id": "019d54f6-b5f2-723d-80b7-1a3347681e4b",
        "storage_key": "property/6767906449167336/019d54f6-b5f2-723d-80b7-1a3347681e4b.webp",
        "width": 934,
        "height": 2000
      },
      "poi_business_url": "https://www.facebook.com/TheFreddysBarberShop",
      "poi_directions_map_url": "https://maps.google.com/?cid=17272134680151160682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "freddys-barbershop",
      "poi_latitude": "33.7934841",
      "poi_longitude": "-83.74538510000001",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 678-635-5065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJydwNzh7R9YgRancd2_rysu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_43a79db8-48bb-4ea0-8de0-135343bb2ac9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "1038 Pavilion Pkwy, Monroe, GA 30656, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-ba33-750d-ac05-ad2bb64fdc14.webp",
      "poi_featured_image_media": {
        "alt_text": "Great Clips online check-in app feature on phones",
        "public_id": "019d54f6-ba33-750d-ac05-ad2bb64fdc14",
        "storage_key": "property/6767906449167336/019d54f6-ba33-750d-ac05-ad2bb64fdc14.webp",
        "width": 888,
        "height": 500
      },
      "poi_business_url": "https://salons.greatclips.com/us/ga/monroe/1038-pavilion-pkwy",
      "poi_directions_map_url": "https://maps.google.com/?cid=18197965243008423345&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-clips",
      "poi_latitude": "33.80549330000001",
      "poi_longitude": "-83.7326901",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-635-8983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyV-XYADR9YgRsRVsuPgojPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_f15ea204-4420-4f93-85e1-50bccfff03af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Front Window Barbershop",
      "poi_type": "Health and Wellness",
      "poi_address": "121 N Midland Ave, Monroe, GA 30655, USA",
      "poi_short_description": "Barbershop offering hair cuts and beard trims for all ages in a clean space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-c063-766e-8e25-0d3141f13a41.webp",
      "poi_featured_image_media": {
        "alt_text": "Commercial building storefronts with signage for Refuge Roofing and Front Window Barbershop.",
        "public_id": "019d54f6-c063-766e-8e25-0d3141f13a41",
        "storage_key": "property/6767906449167336/019d54f6-c063-766e-8e25-0d3141f13a41.webp",
        "width": 3072,
        "height": 1384
      },
      "poi_business_url": "https://www.instagram.com/frontwindowbarbershop",
      "poi_directions_map_url": "https://maps.google.com/?cid=13255067144810380842&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "front-window-barbershop",
      "poi_latitude": "33.7956759",
      "poi_longitude": "-83.7118981",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-635-7494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaZPY-3DR9YgRKr5fAFd187c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_7efdf597-2e2f-4c38-b28a-23ebc7af61e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Piedmont Walton",
      "poi_type": "Health and Wellness",
      "poi_address": "2151 W Spring St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-bda2-730b-8b6d-7ea85f6ca302.webp",
      "poi_featured_image_media": {
        "alt_text": "Piedmont building exterior with a logo on the front.",
        "public_id": "019d54f6-bda2-730b-8b6d-7ea85f6ca302",
        "storage_key": "property/6767906449167336/019d54f6-bda2-730b-8b6d-7ea85f6ca302.webp",
        "width": 2119,
        "height": 1191
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-walton?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTcwMTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6478331243027135963&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "piedmont-walton",
      "poi_latitude": "33.79880929999999",
      "poi_longitude": "-83.75027109999999",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-267-8461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f2f-75d0-9099-64509469dd68.webp",
      "poi_map_icon_media": {
        "alt_text": "Logo of the property or management company",
        "public_id": "019d54f7-1f2f-75d0-9099-64509469dd68",
        "storage_key": "property/6767906449167336/019d54f7-1f2f-75d0-9099-64509469dd68.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJaRUeC_fQ9YgR233yHfGn51k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_94d4c10f-ff51-4af9-a8cf-54bb739c4a8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Excellent Pediatrics",
      "poi_type": "Health and Wellness",
      "poi_address": "333 Alcovy St # 1, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-c469-70f8-b6cb-9106d1a68234.webp",
      "poi_featured_image_media": {
        "alt_text": "A diverse group of medical professionals smiling and posing for a photo in front of a colorful wall mural.",
        "public_id": "019d54f6-c469-70f8-b6cb-9106d1a68234",
        "storage_key": "property/6767906449167336/019d54f6-c469-70f8-b6cb-9106d1a68234.webp",
        "width": 3072,
        "height": 1895
      },
      "poi_business_url": "http://www.excellentpediatrics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6831791646246025815&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "excellent-pediatrics",
      "poi_latitude": "33.7830203",
      "poi_longitude": "-83.71643879999999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 678-807-2230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f2f-75d0-9099-64509469dd68.webp",
      "poi_map_icon_media": {
        "alt_text": "Logo of the property or management company",
        "public_id": "019d54f7-1f2f-75d0-9099-64509469dd68",
        "storage_key": "property/6767906449167336/019d54f7-1f2f-75d0-9099-64509469dd68.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJe3Tl6vbQ9YgRV7r5TU5mz14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_d100b77f-c4d9-45b6-afef-737d6c91e4a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Criswell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Q72R+6P, 1190 Criswell Rd SE, Monroe, GA 30655, USA",
      "poi_short_description": "Playground with slides and swings, plus a baseball field, as well as a disc golf course.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-ca86-708a-93bb-0fb878860736.webp",
      "poi_featured_image_media": {
        "alt_text": "Youth baseball team lining up on the field.",
        "public_id": "019d54f6-ca86-708a-93bb-0fb878860736",
        "storage_key": "property/6767906449167336/019d54f6-ca86-708a-93bb-0fb878860736.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.waltoncountyga.gov/facilities/facility/details/Criswell-Park-4",
      "poi_directions_map_url": "https://maps.google.com/?cid=3474796371522905082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "criswell-park",
      "poi_latitude": "33.7492286",
      "poi_longitude": "-83.70888289999999",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-267-7525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f54-779c-826c-8e819f89524a.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d54f7-1f54-779c-826c-8e819f89524a",
        "storage_key": "property/6767906449167336/019d54f7-1f54-779c-826c-8e819f89524a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb4dP3hLR9YgR-mNwv-P0ODA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fbd81027-e195-4e5b-a29f-d9332f2e0989",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Felker Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "725 S Madison Ave, Monroe, GA 30655, USA",
      "poi_short_description": "Park featuring fields for football and other sports, plus a playground, trail, and bathrooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-caa4-7363-9bd0-426cff018ce2.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "019d54f6-caa4-7363-9bd0-426cff018ce2",
        "storage_key": "property/6767906449167336/019d54f6-caa4-7363-9bd0-426cff018ce2.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://waltoncountyga.gov/186/Felker-Park-Community-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=12775171674531412532&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "felker-park",
      "poi_latitude": "33.785543",
      "poi_longitude": "-83.703751",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-267-7525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f54-779c-826c-8e819f89524a.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d54f7-1f54-779c-826c-8e819f89524a",
        "storage_key": "property/6767906449167336/019d54f7-1f54-779c-826c-8e819f89524a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTwOxS-nQ9YgRNLoTxfOGSrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0f751c37-5e42-4b32-b668-48c69a05b64c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Mathews Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1016 E Marable St, Monroe, GA 30655, USA",
      "poi_short_description": "Kid-friendly park with a playground, picnic tables, and a public restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-de19-70f8-9c97-17e2ce33e559.webp",
      "poi_featured_image_media": {
        "alt_text": "Scenic view of a lake with trees and a bench, geese in the foreground.",
        "public_id": "019d54f6-de19-70f8-9c97-17e2ce33e559",
        "storage_key": "property/6767906449167336/019d54f6-de19-70f8-9c97-17e2ce33e559.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1120728064235908160&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mathews-park",
      "poi_latitude": "33.8184048",
      "poi_longitude": "-83.7037987",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-267-7525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f54-779c-826c-8e819f89524a.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d54f7-1f54-779c-826c-8e819f89524a",
        "storage_key": "property/6767906449167336/019d54f7-1f54-779c-826c-8e819f89524a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWW4oIXTa9YgRQKyXjjygjQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_be365c3c-54ef-46e4-85de-5972fa2f622f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Pilot Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Club Park, Monroe, GA 30655, USA",
      "poi_short_description": "Clean, fenced playground geared towards younger visitors and their families.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-d1ab-74f8-9def-ec8e81da03ea.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides, swings, and climbing structures.",
        "public_id": "019d54f6-d1ab-74f8-9def-ec8e81da03ea",
        "storage_key": "property/6767906449167336/019d54f6-d1ab-74f8-9def-ec8e81da03ea.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.monroega.com/parksrec/page/pilot-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8885073325072989407&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pilot-park",
      "poi_latitude": "33.7930834",
      "poi_longitude": "-83.7062646",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f54-779c-826c-8e819f89524a.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d54f7-1f54-779c-826c-8e819f89524a",
        "storage_key": "property/6767906449167336/019d54f7-1f54-779c-826c-8e819f89524a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo_5QL5PQ9YgR3zxGMB0fTns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_6ecaa5cd-7292-4eec-995e-d65336b97f9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Childers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Monroe, GA 30655, USA",
      "poi_short_description": "Fenced dog park featuring an obstacle course, plus a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-d144-73eb-8bb2-7cf6892f8584.webp",
      "poi_featured_image_media": {
        "alt_text": "Polka dot painted fire hydrant.",
        "public_id": "019d54f6-d144-73eb-8bb2-7cf6892f8584",
        "storage_key": "property/6767906449167336/019d54f6-d144-73eb-8bb2-7cf6892f8584.webp",
        "width": 1080,
        "height": 1440
      },
      "poi_business_url": "http://monroega.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10813340640119652112&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "childers-park",
      "poi_latitude": "33.7933265",
      "poi_longitude": "-83.7166199",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-266-5331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f54-779c-826c-8e819f89524a.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d54f7-1f54-779c-826c-8e819f89524a",
        "storage_key": "property/6767906449167336/019d54f7-1f54-779c-826c-8e819f89524a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1V4ELovQ9YgREH-gSQW0EJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d7d0eba6-e4d1-4117-a460-6785fbf7f19f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Monroe-Walton County Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "525 Towler St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-e4c2-77a6-8d60-3bcc5f5526c9.webp",
      "poi_featured_image_media": {
        "alt_text": "Two women pose in front of a small airplane with \"FlightTrainMonroe.com\" visible on the hangar behind them.",
        "public_id": "019d54f6-e4c2-77a6-8d60-3bcc5f5526c9",
        "storage_key": "property/6767906449167336/019d54f6-e4c2-77a6-8d60-3bcc5f5526c9.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.monroega.com/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=15173581300786590281&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "monroe-walton-county-airport",
      "poi_latitude": "33.7779182",
      "poi_longitude": "-83.694124",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f5f-76da-bdda-22cd6da409ac.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d54f7-1f5f-76da-bdda-22cd6da409ac",
        "storage_key": "property/6767906449167336/019d54f7-1f5f-76da-bdda-22cd6da409ac.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJNdpknMTQ9YgRSfLky8xjk9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_bbc0d0d6-1d28-463a-ba20-931a4f3d097b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Grow Monroe Bait and Tackle",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1124 S Broad St, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-ffbe-711d-be2a-686bdef078dd.webp",
      "poi_featured_image_media": {
        "alt_text": "Vintage gardening tools and signs mounted on a wooden wall.",
        "public_id": "019d54f6-ffbe-711d-be2a-686bdef078dd",
        "storage_key": "property/6767906449167336/019d54f6-ffbe-711d-be2a-686bdef078dd.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3022376063067343544&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grow-monroe-bait-and-tackle",
      "poi_latitude": "33.7802921",
      "poi_longitude": "-83.707658",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-808-9202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_6ClftnR9YgRuMrFIASj8Sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7d72edbd-dfd7-474f-b3ae-99527ebf5b4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Creekside by Starlight Homes",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1957 GA-83, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f6-fb64-70be-83c3-dc60e8fbeb85.webp",
      "poi_featured_image_media": {
        "alt_text": "Construction site with heavy machinery and materials under a blue sky.",
        "public_id": "019d54f6-fb64-70be-83c3-dc60e8fbeb85",
        "storage_key": "property/6767906449167336/019d54f6-fb64-70be-83c3-dc60e8fbeb85.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12317988797537717069&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "creekside-by-starlight-homes",
      "poi_latitude": "33.7960242",
      "poi_longitude": "-83.646847",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ17k9gU7X9YgRTQt6QIxJ8qo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1c863bec-8b0e-45da-b5b1-70dc8bb61171",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Brookstone Construction Group",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1645 GA-138, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-001f-759a-95a8-3bfb2fb8424a.webp",
      "poi_featured_image_media": {
        "alt_text": "Spacious open-concept living area with a large kitchen island, fireplace, and seating.",
        "public_id": "019d54f7-001f-759a-95a8-3bfb2fb8424a",
        "storage_key": "property/6767906449167336/019d54f7-001f-759a-95a8-3bfb2fb8424a.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://brookstonecg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8270927553963672691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brookstone-construction-group",
      "poi_latitude": "33.7820815",
      "poi_longitude": "-83.7706596",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 678-251-8029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAQVNDP9YgRc8T-AMo8yHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f6825916-29ee-4d5d-b593-5d99f440adbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "poi_name": "Transitional Care Physicians of Georgia P.C.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "704 Breedlove Dr, Monroe, GA 30655, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tcpamd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11967481435371372345&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "transitional-care-physicians-of-georgia-pc",
      "poi_latitude": "33.78262369999999",
      "poi_longitude": "-83.7206842",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 888-772-0076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic black circle icon",
        "public_id": "019d54f7-1f30-7278-86f7-9b0dfb015f11",
        "storage_key": "property/6767906449167336/019d54f7-1f30-7278-86f7-9b0dfb015f11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhSv_ggYE9YgROX9kg_UIFaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_ce4b1da0-23f3-456b-8c35-187d078d52ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_aa05d258-4223-4cf2-8306-89f23d570767",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_fca5968a-fef4-4fe3-83a2-81ebfec33224",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6476b019-1d5a-4580-8a81-97b571c062bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b560e4e9-7074-4808-924c-9ab78533408d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b9b542f7-147d-4a0f-baea-75d500b96b68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_a92540b9-bdb7-4050-800f-1620497d92ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_6f6a79f8-89d2-40f3-8dec-e90471471c64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "rating": "5.0",
      "name": "Jason",
      "text": "Been here at the Jax for 9-10 months now. I love it here. Brielle is AWESOME!!!  She was the first encounter I had when I came to tour the apartments. Super friendly and knowledgeable about the complex and retailers in the area. She called me by name on our second or third encounter. She is very personable, remembering to ask about my new grandson every time I see her. Brielle even picked up a gift for me to give to him!!!  How thoughtful. The apartments here are awesome with very user friendly floor plans. There is no waisted space. Only had one small work order placed that was taken care of in short order. Overall, complex is kept neat and orderly. Breezeways and common areas are well maintained also. Location is close to downtown and being right off 78 it makes getting just about anywhere super easy. Highly recommend the Jax!!!",
      "date": "2026-03-04",
      "title": ""
    },
    {
      "id": "custom_29828832-0287-4705-b7b2-25a1fd36f384",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "rating": "5.0",
      "name": "Austin Weeks",
      "text": "I recently went through the leasing process at The Jax, and I cannot recommend the experience highly enough. This is specifically due to the incredible work of Nina. Finding a new home can usually be a stressful and overwhelming ordeal, but Nina made the entire journey seamless, transparent, and actually enjoyable.\nWhy Nina Stands Out\nExpert Knowledge\nFrom the moment I walked into the leasing office, Nina demonstrated an impressive understanding of the property. She did more than just show me a unit. She explained the unique layout features, the community vision, and provided detailed answers about the building’s construction and amenities.\nAttentiveness to Detail\nNina took the time to listen to exactly what I was looking for in a floor plan and budget. She focused on finding the perfect unit that checked every one of my boxes rather than pushing unnecessary options.\nCommunication\nI was never left wondering where my application stood. Nina was proactive by following up via email and phone to ensure I had all my paperwork in order. Her response times are lightning fast, which is a rare find in property management.\nGenuine Professionalism\nBeyond the technical side of leasing, Nina has a warm and welcoming personality. She makes you feel like a valued member of the community before you even sign the lease. She went above and beyond to make sure I felt comfortable and confident in my decision.\n\nIf you are considering moving to The Jax, do yourself a favor and ask for Nina. Her professionalism, kindness, and dedication to her residents are truly what set this building apart from others in the area. Thank you, Nina, for making my move in experience so positive.",
      "date": "2026-01-11",
      "title": ""
    },
    {
      "id": "custom_47483904-40e6-4b02-83e3-08c1795d1761",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "rating": "5.0",
      "name": "Doug Hamilton",
      "text": "Had a fantastic visit at Jax! Madison and Nina were incredibly welcoming and knowledgeable throughout the tour. They answered all my questions, highlighted every detail of the community, and made the entire experience smooth and enjoyable. The property is beautiful, well-maintained, and thoughtfully designed. Their professionalism and friendliness really stood out. Highly recommend scheduling a visit!",
      "date": "2025-12-09",
      "title": ""
    },
    {
      "id": "custom_c734897e-d436-4046-aaf0-07c56e59ec62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "rating": "5.0",
      "name": "Olivia Conner",
      "text": "Nina was the person we worked with directly when we moved in back in Oct. She was amazing. Answered all the million questions I had, took her time to explain, and even now if I have any issues I deal with her directly as she’s on top or everything. Recommend Nina for anything to do with The Jax!",
      "date": "2026-01-19",
      "title": ""
    },
    {
      "id": "custom_62fc426a-f2fb-4630-a491-d4e75ca457a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "rating": "5.0",
      "name": "Loretta Cohen",
      "text": "Madison is the best! She is very helpful, informative and friendly. The JAX Apartments is a beautiful complex and has many wonderful amenities. It is very convenient to Shopping and Downtown Monroe. I looking forward to moving! ❤️",
      "date": "2026-06-04",
      "title": ""
    },
    {
      "id": "custom_cb26196d-03ad-4fe4-be2d-b1468823e48b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "rating": "5.0",
      "name": "Cynthia Gordon",
      "text": "My experience with the Jax has been so wonderful. I saw the apartment online and fell in love with it. I came for a tour with Madison and she was so patient, transparent and very knowledgeable about the community and any questions i had. I came back when i was fully ready to apply and start my lease and Madison still remembered me after a couple of months. That really stood out to me and showed me that the Jax is a community that cares about people. Thanks to Madison, I’m less anxious about leasing my first apartment and more excited for my future at the Jax.",
      "date": "2026-06-29",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_aca2483f25bfd6a19f8239a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f8-b9f7-722f-9eb4-5ace1db17e5f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54f8-b9f7-722f-9eb4-5ace1db17e5f",
        "storage_key": "property/6767906449167336/019d54f8-b9f7-722f-9eb4-5ace1db17e5f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,120SF - The Monroe",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kGig1C5HBGH"
    },
    {
      "id": "ec_bcf0aaf6871c5282395d737a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f8-ba05-74c8-816d-7dfd89689804.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54f8-ba05-74c8-816d-7dfd89689804",
        "storage_key": "property/6767906449167336/019d54f8-ba05-74c8-816d-7dfd89689804.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 835SF - The Creek",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eEUw7h5EWye"
    },
    {
      "id": "ec_0aad1a57ba7de73bcef85ce5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f8-bb49-717c-9de6-510b987e51b7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54f8-bb49-717c-9de6-510b987e51b7",
        "storage_key": "property/6767906449167336/019d54f8-bb49-717c-9de6-510b987e51b7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,265SF - The Bay",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=RU3UP4GTDaX"
    },
    {
      "id": "ec_345672a9f1fa2141233ee413",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f8-bb10-74b8-a826-7c4a2e9f1260.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54f8-bb10-74b8-a826-7c4a2e9f1260",
        "storage_key": "property/6767906449167336/019d54f8-bb10-74b8-a826-7c4a2e9f1260.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2BA - 1,448SF - The Brook",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QZS7f79rCXc"
    },
    {
      "id": "ec_1454b11cb767b1402fc08ab2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f8-bac4-7507-82ce-5e40f6d89b0e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54f8-bac4-7507-82ce-5e40f6d89b0e",
        "storage_key": "property/6767906449167336/019d54f8-bac4-7507-82ce-5e40f6d89b0e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,390SF - The Jack",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=x6LatzucpTp"
    },
    {
      "id": "ec_2e72001e2698d321f286a326",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f8-bbbc-711f-ab0e-3016af08560b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d54f8-bbbc-711f-ab0e-3016af08560b",
        "storage_key": "property/6767906449167336/019d54f8-bbbc-711f-ab0e-3016af08560b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,254SF - The Cove",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=XTSBxALi6wq"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db23f-d1de-75ab-8279-b3cdf45c12bd",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Jax Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336"
    },
    {
      "lead_collector_id": "019db23f-d258-71da-948a-2b97fd44fefe",
      "lead_source": "FACEBOOK_ADS",
      "name": "The Jax Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336"
    },
    {
      "lead_collector_id": "019db23f-d2ce-74bb-955d-b11d7c13895b",
      "lead_source": "LANDING_PAGE",
      "name": "The Jax Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "luxury-dog-park-apartments-monroe-ga",
      "search_query": "luxury dog park apartments in Monroe GA",
      "category": "Amenity",
      "h1_title": "Luxury Dog Park Apartments in Monroe, GA",
      "h2_subtitle": "Discover the perfect home in Monroe, GA with a luxury dog park. Upscale amenities and pet-friendly living await at The Jax.",
      "page_copy": "Nestled in the heart of Monroe, GA, The Jax offers an unparalleled living experience for pet lovers seeking luxury dog park apartments. Our community understands the importance of a welcoming environment for both you and your furry friends. Enjoy the convenience of our premium amenities, including stainless steel appliances and a complimentary coffee bistro, all within a pet-friendly atmosphere.\n\nThe Jax stands out with its open concept living spaces and state-of-the-art Luxor One package lockers. Our gated community ensures security while providing easy access to everything Monroe has to offer. Our luxury dog park is perfect for playful interactions and bonding with your pet. Join us at The Jax, where comfortable living and pet-friendly charm converge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Dog Park Apartments in Monroe, GA",
      "seo_description": "Explore luxury dog park apartments in Monroe, GA at The Jax, offering top amenities like stainless steel appliances and a coffee bistro.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "resort-style-pool-apartments-monroe-walton",
      "search_query": "resort style pool apartments Monroe Walton County",
      "category": "Amenity",
      "h1_title": "Resort Style Pool Apartments in Monroe",
      "h2_subtitle": "Experience resort-like living in Monroe, Walton County, with exquisite pool amenities at The Jax. Indulge in a unique lifestyle within our community.",
      "page_copy": "The Jax in Monroe, Walton County, invites you to experience upscale living with our resort style pool apartments. Offering a harmonious blend of leisure and luxury, our community features top-tier amenities, including stainless steel appliances and a complementary coffee bistro, designed for your comfort.\n\nEnjoy the serenity of our open concept living spaces, and take advantage of our Luxor One package lockers for practical convenience. Our gated access enhances your peace of mind while the resort-style pool provides a perfect spot to relax and unwind. Dive into the tranquil lifestyle at The Jax, where resort-style amenities meet authentic Southern hospitality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort Style Pool Apartments in Monroe, GA",
      "seo_description": "Discover resort style pool apartments in Monroe, Walton County. Enjoy luxury living and premium amenities at The Jax.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "apartments-in-unit-washer-dryer-monroe-30656",
      "search_query": "apartments with in unit washer dryer Monroe 30656",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer Dryer in Monroe",
      "h2_subtitle": "Enjoy convenience and comfort with in-unit washer and dryer at The Jax in Monroe, 30656. Our apartments are designed with your lifestyle in mind.",
      "page_copy": "At The Jax in Monroe, 30656, we prioritize convenience by offering apartments with in-unit washer and dryer facilities. Located in the charming Walton County, our community blends modern living with exceptional amenities, including stainless steel appliances and a delightful coffee bistro.\n\nLiving at The Jax, you'll appreciate the ease of having laundry solutions right in your apartment alongside open concept living spaces. Our secure, gated community also features innovative Luxor One package lockers to simplify your daily routine. Experience the combination of comfort and convenience at The Jax, tailored precisely for modern lifestyles.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Monroe Apartments with In-Unit Washer Dryer",
      "seo_description": "Find apartments with in-unit washer dryer in Monroe, 30656 at The Jax. Enjoy convenience and luxury living in Walton County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "monroe-apartments-fitness-center",
      "search_query": "Monroe apartments with state of the art fitness center",
      "category": "Amenity",
      "h1_title": "Monroe Apartments with Fitness Center",
      "h2_subtitle": "Embrace an active lifestyle at The Jax, featuring a state-of-the-art fitness center. Perfectly situated in Monroe, our amenities are designed for your wellness.",
      "page_copy": "At The Jax, discover the perfect blend of lifestyle and fitness with our Monroe apartments featuring a state-of-the-art fitness center. Located in the vibrant community of Monroe, our residences are designed to cater to those seeking a balanced lifestyle with top-class amenities, including stainless steel appliances and a charming coffee bistro.\n\nOur fitness center offers cutting-edge equipment, ensuring you can maintain your workout regimen in the comfort of your living community. Alongside controlled access and Luxor One package lockers, The Jax provides an exceptional environment to live and thrive. Join us in Monroe and experience the superior living standards at The Jax.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Monroe Apartments with Fitness Center",
      "seo_description": "Discover Monroe apartments with a state-of-the-art fitness center at The Jax. Enjoy modern living and top amenities designed for you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "ev-charging-station-apartments-walton-county",
      "search_query": "EV charging station apartments in Walton County",
      "category": "Amenity",
      "h1_title": "EV Charging Station Apartments Walton County",
      "h2_subtitle": "Live sustainably with EV charging station apartments in Walton County at The Jax. Enjoy modern amenities in a conveniently located community.",
      "page_copy": "The Jax in Walton County offers a progressive living experience with our EV charging station apartments. Designed for eco-conscious residents, our community supports sustainable living while providing a variety of luxurious amenities, like stainless steel appliances and a complementary coffee bistro.\n\nOur open concept living spaces are complemented by features such as Luxor One package lockers and secure gated access. With the added convenience of an EV charging station, The Jax stands out as a community that merges innovation with comfort in scenic Walton County. Experience the future of living at The Jax, where sustainability meets style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "EV Charging Station Apartments in Walton",
      "seo_description": "Find EV charging station apartments in Walton County at The Jax. Enjoy sustainable and modern living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-monroe-ga",
      "search_query": "one bedroom apartments in Monroe GA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Monroe, GA",
      "h2_subtitle": "Discover comfortable one-bedroom apartments at The Jax in Monroe, GA. Tailored amenities make these homes ideal for a modern lifestyle.",
      "page_copy": "The Jax offers one-bedroom apartment homes in Monroe, GA. These apartment homes feature open-concept layouts, stainless steel appliances, and modern finishes designed to support everyday apartment living.\n\nCommunity amenities include a coffee bistro and controlled access entry. Located in Monroe, The Jax combines modern apartment amenities with convenient access to local attractions, shopping, dining, and other area destinations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Monroe, GA",
      "seo_description": "Find one bedroom apartments in Monroe, GA at The Jax. Modern amenities and design meet comfort in our welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-walton-county",
      "search_query": "two bedroom apartments Walton County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Walton County",
      "h2_subtitle": "Discover spacious two-bedroom apartments in Walton County at The Jax. Modern amenities and open layouts offer unmatched comfort and style.",
      "page_copy": "The Jax offers two-bedroom apartment homes in Walton County featuring open-concept layouts, stainless steel appliances, and modern finishes. These floor plans provide additional living space and practical apartment conveniences.\n\nCommunity amenities include controlled access entry, Luxor One package lockers, and a coffee bistro. The Jax combines modern apartment features with convenient access to local amenities and services throughout Walton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Walton County",
      "seo_description": "Explore two-bedroom apartments in Walton County at The Jax, featuring modern amenities and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-30656",
      "search_query": "three bedroom apartments near 30656",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 30656",
      "h2_subtitle": "Explore expansive three-bedroom apartments near 30656 at The Jax. Enjoy spacious living with modern features and comforts.",
      "page_copy": "The Jax offers three-bedroom apartment homes near the 30656 area of Monroe, GA. These floor plans provide additional living space, flexible layouts, stainless steel appliances, and open-concept living areas.\n\nCommunity amenities include a coffee bistro, Luxor One package lockers, and a gated entrance. Located in Walton County, The Jax combines modern apartment amenities with practical conveniences and convenient access to local attractions and services throughout Monroe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 30656",
      "seo_description": "Find spacious three-bedroom apartments near 30656 at The Jax. Enjoy modern living with spacious layouts and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "apartments-near-george-walton-academy-monroe-ga",
      "search_query": "apartments near George Walton Academy Monroe",
      "category": "School",
      "h1_title": "Apartments Near George Walton Academy Monroe",
      "h2_subtitle": "Discover ideal apartments near George Walton Academy in Monroe. The Jax offers a convenient location with top amenities.",
      "page_copy": "The Jax offers apartment homes conveniently located near George Walton Academy in Monroe, GA. The community provides convenient access to nearby schools, local services, shopping, dining, and other area amenities.\n\nApartment features include open-concept floor plans, stainless steel appliances, and modern finishes. Community amenities include a controlled access gate, Luxor One package lockers, and a coffee bistro. The Jax combines modern apartment amenities with a convenient location in Monroe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near George Walton Academy Monroe",
      "seo_description": "Find modern apartments near George Walton Academy in Monroe at The Jax. Enjoy convenience and top amenities in our welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "rentals-close-to-athens-technical-college-walton",
      "search_query": "rentals close to Athens Technical College Walton County",
      "category": "School",
      "h1_title": "Rentals Close to Athens Tech College Walton",
      "h2_subtitle": "Find rentals conveniently close to Athens Technical College in Walton County. The Jax offers modern amenities for comfortable living.",
      "page_copy": "The Jax offers apartment homes conveniently located near Athens Technical College in Walton County. The community provides convenient access to nearby educational facilities, local services, shopping, dining, and other area amenities.\n\nApartment features include open-concept layouts, stainless steel appliances, and modern finishes. Community amenities include a gated entrance, Luxor One package lockers, and a coffee bistro. The Jax combines modern apartment amenities with a convenient location near Athens Technical College and other destinations throughout the area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Athens Tech College Walton",
      "seo_description": "Discover rentals close to Athens Technical College in Walton County at The Jax. Enjoy a prime location and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "apartments-near-piedmont-walton-hospital-monroe-ga",
      "search_query": "apartments near Piedmont Walton Hospital Monroe GA",
      "category": "Hospital",
      "h1_title": "Apartments Near Piedmont Walton Hospital",
      "h2_subtitle": "Explore apartments near Piedmont Walton Hospital in Monroe, GA. The Jax offers a convenient and modern living experience.",
      "page_copy": "The Jax offers apartment homes conveniently located near Piedmont Walton Hospital in Monroe, GA. The community provides convenient access to healthcare facilities, local services, and nearby amenities.\n\nApartment features include open-concept layouts, stainless steel kitchen appliances, and modern finishes. Community amenities include controlled access, a Luxor One package system, and a coffee bistro. The Jax combines modern apartment amenities with a convenient location near Piedmont Walton Hospital and other destinations throughout Monroe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Piedmont Walton Hospital",
      "seo_description": "Find modern apartments near Piedmont Walton Hospital in Monroe, GA at The Jax. Experience convenient living with top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "apartments-near-criswell-park-monroe-ga",
      "search_query": "apartments near Criswell Park Monroe GA",
      "category": "Park",
      "h1_title": "Apartments Near Criswell Park Monroe GA",
      "h2_subtitle": "Discover apartments near Criswell Park in Monroe, GA. The Jax provides a vibrant living experience with easy access to local attractions.",
      "page_copy": "The Jax is an excellent choice for anyone searching for apartments near Criswell Park in Monroe, GA. Located just minutes from this local gem, The Jax offers residents a perfect blend of outdoor relaxation and modern apartment living. Enjoy the elegance of open concept living spaces that include high-end features like stainless steel appliances.\n\nOur community is designed to enhance the everyday experience with amenities such as controlled access, Luxor One package lockers, and a complementary coffee bistro. Living near Criswell Park means easy access to lush green spaces while being part of a welcoming community. The Jax combines convenience with an active lifestyle that embraces both urban living and nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Criswell Park Monroe GA",
      "seo_description": "Find vibrant apartments near Criswell Park in Monroe, GA at The Jax. Enjoy modern amenities and easy access to local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "felker-park-nearby-apartments-walton-county",
      "search_query": "Felker Park nearby apartments Walton County",
      "category": "Park",
      "h1_title": "Felker Park Nearby Apartments",
      "h2_subtitle": "Explore nearby apartments to Felker Park in Walton County. The Jax offers a perfect blend of outdoor access and luxurious living.",
      "page_copy": "If you're on the hunt for apartments near Felker Park in Walton County, look no further than The Jax. Our community offers prime access to one of the area's beloved parks, perfect for leisure and recreation. The Jax combines the tranquility of nearby green spaces with the sophistication of upscale apartment features, such as open concept living and stainless steel appliances.\n\nResidents at The Jax benefit from a comprehensive suite of amenities including controlled gated access, Luxor One package lockers, and a delightful coffee bistro. Enjoy a serene environment with convenient access to the park, ensuring that your weekends are filled with outdoor adventures while weekdays remain elegant and comfortable.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Felker Park Nearby Apartments",
      "seo_description": "Discover The Jax, offering luxurious living with easy access to Felker Park in Walton County. Enjoy nature and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "apartments-close-to-mathews-park-within-monroe",
      "search_query": "apartments close to Mathews Park within Monroe",
      "category": "Park",
      "h1_title": "Apartments Close to Mathews Park",
      "h2_subtitle": "Find apartments close to Mathews Park within Monroe, GA. The Jax blends modern living with proximity to local attractions.",
      "page_copy": "The Jax offers apartment homes conveniently located near Mathews Park in Monroe. The community provides convenient access to outdoor recreation opportunities, green space, and nearby local amenities.\n\nApartment features include open-concept layouts and stainless steel appliances. Community amenities include controlled access entry, a Luxor One package system, and a coffee bistro. The Jax combines modern apartment amenities with convenient access to Mathews Park and other destinations throughout Monroe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Mathews Park",
      "seo_description": "Choose The Jax for modern apartments close to Mathews Park in Monroe, GA. Enjoy local nature and amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167336",
      "source": "custom",
      "page_item_url": "childers-park-apartments-monroe-30656",
      "search_query": "Childers Park apartments Monroe 30656",
      "category": "Park",
      "h1_title": "Childers Park Apartments in Monroe 30656",
      "h2_subtitle": "Discover apartments near Childers Park in Monroe 30656. The Jax offers a unique blend of comfort and convenience.",
      "page_copy": "For those searching for Childers Park apartments in Monroe 30656, The Jax is an exceptional choice. Located in a serene neighborhood, our community is perfect for nature lovers who value easy access to Childers Park. Our apartments feature open concept living spaces and modern stainless steel appliances, perfect for a contemporary lifestyle.\n\nBeyond individual apartment features, The Jax offers enhanced community living with amenities like controlled access, Luxor One package lockers, and a relaxing coffee bistro. Being near Childers Park allows our residents to enjoy the tranquility of nature while savoring the comforts of home. Experience the perfect balance of natural beauty and luxurious apartment living at The Jax.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
      "featured_image_media": {
        "alt_text": "Exterior of the apartment building",
        "public_id": "019d54f7-0912-7298-81f0-fe80af955904",
        "storage_key": "property/6767906449167336/019d54f7-0912-7298-81f0-fe80af955904.webp",
        "width": 1,
        "height": 1
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Childers Park Apartments Monroe 30656",
      "seo_description": "Live near Childers Park in Monroe 30656 at The Jax. Enjoy modern living with convenient park access and fantastic amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6151"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671056444"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-K56JVTMF"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "21798383754"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "46dba5d449ec11ef"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "b484f0cc984e11eebcb40e136090bd39"
    },
    {
      "ID": "custom_call_rail_company_id",
      "type": "STRING",
      "value": "801088586"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8epm6l44v6d"
    },
    {
      "ID": "custom_call_rail_account_hash",
      "type": "STRING",
      "value": "4c07f21bb0ecf5c04da6"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "a1347080-d0cb-11f0-a5a3-3b46cb62d9b2"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6767906449167336/019f94ba-c9ea-73ec-b9d6-d49e9266894c.mp4"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a1347080-d0cb-11f0-a5a3-3b46cb62d9b2/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlliSTJ2M09SdVhSNWNFSm5XTVRaMXc9PSIsInZhbHVlIjoiZHFxWkg2UUFiZldJQUFZUjlEWE90Zz09IiwibWFjIjoiNDM4MTA2ZWY2YTBjODlkYmM3MDc4YWY1OTQ4NjA0Yjk1YzI1NzkzODZmZjllNTQwZDExMzM1OTI2OTU4NGIwMSJ9"
    }
  ],
  "custom_qb_id": "6151",
  "custom_repli_id": "11671056444",
  "custom_google_gtm_id": "GTM-K56JVTMF",
  "custom_hubspot_company_id": "21798383754",
  "custom_knock_community_id": "46dba5d449ec11ef",
  "custom_knock_company_token": "b484f0cc984e11eebcb40e136090bd39",
  "custom_call_rail_company_id": "801088586",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/8epm6l44v6d",
  "custom_call_rail_account_hash": "4c07f21bb0ecf5c04da6",
  "custom_eliseai_building_token": "a1347080-d0cb-11f0-a5a3-3b46cb62d9b2",
  "custom_eliseai_organization_id": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57",
  "custom_property_featured_video": "https://media.multihub.io/property/6767906449167336/019f94ba-c9ea-73ec-b9d6-d49e9266894c.mp4",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/a1347080-d0cb-11f0-a5a3-3b46cb62d9b2/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlliSTJ2M09SdVhSNWNFSm5XTVRaMXc9PSIsInZhbHVlIjoiZHFxWkg2UUFiZldJQUFZUjlEWE90Zz09IiwibWFjIjoiNDM4MTA2ZWY2YTBjODlkYmM3MDc4YWY1OTQ4NjA0Yjk1YzI1NzkzODZmZjllNTQwZDExMzM1OTI2OTU4NGIwMSJ9",
  "custom_audioeye_site_id": "96869d6c-dfa3-4bc1-bb60-6defa22db88a",
  "custom_audioeye_site_hash": "c91fe233017106983436917ab8a698a1"
};

export const generatedAt = '2026-10-01T17:23:36.473Z';
